import React from 'react';
import $ from 'jquery';
import LeftNav from './../common/leftnav/leftnav';
import HeaderTop from './../common/headerTop/headerTop';
import Snapshot from './../server/snapshots/snapshots';
import ImageService from './../../services/image.service';
import CommonMessage from './../common/commonMessage';
import { ServerService as instanceService } from './../../services/server.service';
import ReactToolTip from 'react-tooltip';
import './../server/Region.css';
import Axios from 'axios';
import { API_HOST, axiosRequestWithAuth, axiosInstance } from './../../constants/server.constant';
import RegionService from './../../services/region.service';
import { AuditLog } from './../../services/auditlog.service';
import { formatBytesFloat, removeSpecialCharacter } from '../../utility/utility';
import { CancelToken } from 'axios';
import { Redirect } from 'react-router-dom';
import { ResourceService } from './../../services/resource.service';
import ScrollArea from 'react-scrollbar';
import NotificationSlider from '../common/topRightHeader/notificationSlider';
import BmrSlider from '../common/topRightHeader/bmrSlider';
import { loginService } from '../../services/login.service';
class Images extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            imagesBackups: [],
            imageSnapshots: [],
            customImages: [],
            regionList: [],
            backupname: "",
            region: "",
            imageName: "",
            imageid: "",
            enableimageoptions: false,
            enablebackupedit: false,
            enableimageupload: false,
            enableimageurl: false,
            enableimagedelete: false,
            imagetype: "backups",
            imagedeleteid: "",
            imagedeletregion: "",
            imagedeletename: "",
            message: "",
            msgType: "",
            containerformat: [],
            diskformat: [],
            editImageName: "",
            editImageRegion: "",
            editImageId: "",
            uploadRegion: "",
            uploadImageName: "",
            uploadContainerFormat: "",
            uploadDiskFormat: "",
            backupNameToggle: true,
            backupSizeToggle: false,
            backupRegionToggle: false,
            backupDateToggle: false,
            backupStatusToggle: false,
            snapshotNameToggle: true,
            snapshotSizeToggle: false,
            snapshotRegionToggle: false,
            snapshotDateToggle: false,
            snapshotStatusToggle: false,
            customNameToggle: true,
            customSizeToggle: false,
            customRegionToggle: false,
            customDateToggle: false,
            customStatusToggle: false,
            isAction: true,
            showImageUrlBox: false,
            showImageUploadBox: true,
            radioButtonPlan: "upload",
            importImageUrl: "",
            importImageName: "",
            files: "",
            fileName: "",
            fileSize: "",
            getTooltip: false,
            importnameempty: false,
            importurlempty: false,
            uploadnameempty: false,
            uploadfileempty: false,
            uploadfileerror: false,
            regionempty: false,
            regionListFilter: [],
            regionid: "",
            isregionselected: false,
            regionContainerFocus: false,
            countryName: "",
            editnameempty: false,
            nameErrMessg: '',
            progressBarPerc: 0,
            cancelToken: {},
            isCancelled: false,
            isCloseActive: false,
            iseditButtonClick: false,
            isUserSubscribed: false,
            isRedirectToCCPage: false,
            regionMaintList: [],
            isRegionStatus: false,
            regionCount: 0,
            regionString: "",
            isCluster: "",
            isAddRegSlider: false,
            copyImageRegion: "",
            count: 50,
            backupIndexCount: 0,
            snapIndexCount: 0,
            customIndexCount: 0,
            imagesBackupsPaged: [],
            imageSnapshotsPaged: [],
            customSnapshotsPaged: []
        };
        this.uploadnamefocus = React.createRef();
        this.importurlfocus = React.createRef();
        this.uploadRegionFocus = React.createRef();
        this.importnamefocus = React.createRef();
        this.editnamefocus = React.createRef();
        this.checkForSubscription = this.checkForSubscription.bind(this);
        this.closeDeleteImage = this.closeDeleteImage.bind(this);
        this.enableImageOptions = this.enableImageOptions.bind(this);
        this.handleInput = this.handleInput.bind(this);
        this.enableImageUpload = this.enableImageUpload.bind(this);
        this.enableBackupEdit = this.enableBackupEdit.bind(this);
        this.enableImageDelete = this.enableImageDelete.bind(this);
        this.imageType = this.imageType.bind(this);
        this.createInstanceImage = this.createInstanceImage.bind(this);
        this.editImage = this.editImage.bind(this);
        this.downloadImage = this.downloadImage.bind(this);
        this.deleteImage = this.deleteImage.bind(this);
        this.setSortable = this.setSortable.bind(this);
        this.getRadioButtonStatus = this.getRadioButtonStatus.bind(this);
        this.handleFile = this.handleFile.bind(this);
        this.escfunction = this.escfunction.bind(this);
        this.closeUploadImage = this.closeUploadImage.bind(this);
        this.closeEditImage = this.closeEditImage.bind(this);
        this.showToolTip = this.showToolTip.bind(this);
        this.getRegionDropdown = this.getRegionDropdown.bind(this);
        this.filterDropDown = this.filterDropDown.bind(this);
        this.getSelectedRegion = this.getSelectedRegion.bind(this);
        this.getFocus = this.getFocus.bind(this);
        this.enterPressed = this.enterPressed.bind(this);
        this.handleFileOperation = this.handleFileOperation.bind(this);
        this.headerSortClick = this.headerSortClick.bind(this);
        this.loadUploadFunction = this.loadUploadFunction.bind(this);
        this.setProgressBar = this.setProgressBar.bind(this);
    };

    enterPressed(event, param) {
        var code = event.keyCode || event.which;
        if(code === 13 && param === "edit") {
            if(!this.state.iseditButtonClick) {
                this.editImage();
            }

        }
        if(code === 13 && param === "delete") {
            this.deleteImage();
        }
    }
    handleFileOperation = (event) => {
        event.target.value = '';
    };
    closeDeleteImage = () => {
        $(".delete_image_popup").removeClass("active");
        $("body").removeClass("popup_no_scroll");
    };
    cancelUploadImage = () => {
        //this.setState({isCancelled:true})
        //this.state.cancelToken('users canceled')
        $(".upload_image_popup").removeClass("active");
        this.setState({ message: 'Image upload is cancelled', msgType: "success" });
        localStorage.setItem('reload', true);
        localStorage.removeItem("isUpload");
        window.location.reload();
        //$('.ImageModule_CustomImgUpload').removeClass("active");
    };
    fadeOffUploadImageClose = () => {
        $(".upload_image_popup").removeClass("active");
        //$('.ImageModule_CustomImgUpload').removeClass("active");
    };
    openUploadImage = () => {
        localStorage.setItem("isUpload", true);
        //$(".upload_image_popup").addClass("active")
        $('.ImageModule_CustomImgUpload').removeClass("active");
    };
    getFocus = (param) => {
        this.setState({
            regionContainerFocus: true
        });
        if(this.state.radioButtonPlan === "upload") {
            if(param === "name") {
                if(this.state.regionid.length <= 0) {
                    this.setState({
                        regionempty: true
                    });
                }
                else {
                    this.setState({
                        regionempty: false
                    });
                }
            }
            if(param === "file") {
                if(this.state.uploadImageName.length <= 0) {
                    this.setState({
                        uploadnameempty: true
                    });
                }
                else {
                    this.setState({
                        uploadnameempty: false
                    });
                }
                if(this.state.uploadRegion.length <= 0) {
                    this.setState({
                        regionempty: true
                    });
                }
                else {
                    this.setState({
                        regionempty: false
                    });
                }
            }

        }
        if(this.state.radioButtonPlan === "import") {
            if(param === "importurl") {
                if(this.state.regionid.length <= 0) {

                    this.setState({
                        regionempty: true
                    });
                }
                else {
                    this.setState({
                        regionempty: false
                    });
                }
            }
            else if(param === "importname") {
                if(this.state.regionid.length <= 0) {
                    this.setState({
                        regionempty: true
                    });
                }
                else {
                    this.setState({
                        regionempty: false
                    });
                }

                if(this.state.importImageUrl.length <= 0) {
                    this.setState({
                        importurlempty: true
                    });
                }
                else {
                    this.setState({
                        importurlempty: false
                    });
                }
            }

        }
    };
    showToolTip = (event, param) => {
        if(param.length >= 39) {
            this.setState({
                getTooltip: true
            });
        }
        else {
            this.setState({
                getTooltip: false
            });
        }

    };



    closeEditImage = (event) => {
        event.preventDefault();
        if(this.state.imagetype === "backups") {
            $(".ImageModule_editBackup").removeClass("active");
        }
        else if(this.state.imagetype === "snapshot") {
            $(".ImageModule_editSnapshot").removeClass("active");
        }
        else {
            $(".ImageModule_editCustom").removeClass("active");
        }
    };
    closeUploadImage = (event) => {
        event.preventDefault();
        $('.ImageModule_CustomImgUpload').removeClass("active");
        this.setState({
            files: "",
            fileName: "",
            fileSize: "",
            importImageUrl: "",
            importImageName: "",
            uploadImageName: "",
            nameErrMessg: ''
        });

    };

    escfunction(event) {
        if(localStorage.getItem('isImageUpload')) {
            return;
        }
        if(event.keyCode === 27) {
            this.setState({
                enableimagedelete: false,
                enablebackupedit: false,
                enableimageupload: false,
                isAddRegSlider: false
            });
            $('.ImageModule_CustomImgUpload').removeClass('active');
            $('.image_row_options').removeClass('active');
            $(".delete_image_popup").removeClass("active");
            $("body").removeClass("popup_no_scroll");
            if(this.state.imagetype === "backups") {
                $(".ImageModule_editBackup").removeClass("active");
            }
            else if(this.state.imagetype === "snapshot") {
                $(".ImageModule_editSnapshot").removeClass("active");
            }
            else {
                $(".ImageModule_editCustom").removeClass("active");
            }

        }
    }

    deleteCancelImage() {
        let regionId = localStorage.getItem('uploadRegion');
        ImageService.delQueuedImages(regionId).then(resp => {
            console.log(resp);
        });
    }

    componentDidMount() {

        let locationState = this.props.location.state;
        let val = localStorage.getItem('reload');

        if((locationState != undefined && locationState.imagetype != undefined) || val) {
            this.deleteCancelImage();
            localStorage.removeItem('reload');
            this.setState({
                imagetype: "custom"
            });
        }

        if((this.props.location.state != undefined && this.props.location.state.redirectFrom === "instSnap")) {
            if(localStorage.getItem("showCopyRegionMsg") === "show") {
                localStorage.removeItem("showCopyRegionMsg");
                this.setState({
                    imagetype: "custom",
                    message: "Image copy intiated from region " + this.props.location.state.fromRegion + " to " + this.props.location.state.toRegion + " region",
                    msgType: "success"
                });
                setTimeout(() => {
                    this.setState({

                        message: "",
                        msgType: ""
                    });
                }, 10000);
            }



        }

        document.addEventListener("keyup", this.escfunction, false);
        let percent = localStorage.getItem('progressBarPerc');
        if(percent !== undefined && percent !== null && percent > 0) {
            this.setState({
                isAction: true,
                progressBarPerc: percent
            });
            this.setProgressPercentage();
        } else {
            this.setState({
                isAction: true
            });
        }

        if(val) {
            setTimeout(() => {
                this.checkForSubscription();
            }, 100);
        } else {
            this.checkForSubscription();
        }


    }
    checkForSubscription = () => {
        ResourceService.getSubscriptionDetails().then(resp => {
            if(resp === false) {
                this.setState({
                    isAction: false,
                    message: "Error while getting user subscription details",
                    msgType: "error"

                });
                return;
            }
            if(resp.error) {
                this.setState({
                    isAction: false,
                    isUserSubscribed: true
                });
                this.loadRegions();
            }
            else {
                this.getAllImages();
                this.getCopyImageData();
                this.getMaintananceRegions();
                var cluster = localStorage.getItem("clusterMessage");
                if(cluster !== null && cluster !== undefined) {
                    this.setState({
                        isCluster: localStorage.getItem("clusterMessage")
                    });
                }
                else {
                    localStorage.setItem("clusterMessage", "show");
                    this.setState({
                        isCluster: "show"
                    });
                }
                this.imagesListInterval = setInterval(() => this.getAllImages(), 20000);
                this.imagesIdData = setInterval(() => this.getCopyImageData(), 20000);

            }

        });
    };
    getMaintananceRegions = () => {
        let userId = localStorage.getItem("userId");
        axiosInstance.get(API_HOST + "/regions/maintainance/" + userId, axiosRequestWithAuth).
            then(resp => {
                // console.log(resp);
                let res = resp.data;
                let string = "";
                this.setState({
                    regionCount: res.length,
                    regionMaintList: res
                });
                if(res.length > 0) {
                    for(let i = 0; i < res.length; i++) {
                        string += res[i].name + " (" + res[i].region_id + ")" + ", ";
                    }
                    this.setState({
                        isRegionStatus: true,
                        regionString: string.replace(/,\s*$/, "")
                    });
                }

            })
            .catch(error => {
                console.log(error);
            });
    };

    componentWillUnmount() {
        document.removeEventListener("keyup", this.escfunction, false);
        clearTimeout(sessionStorage.progressTimeout);
        clearInterval(this.imagesListInterval);
        clearInterval(this.imagesIdData);
    }

    setProgressPercentage() {
        sessionStorage.progressTimeout = setTimeout(() => {
            let percent = localStorage.getItem('progressBarPerc');
            if(percent !== undefined && percent > 0) {
                this.setState({ progressBarPerc: percent });
                this.setProgressPercentage();
            } else {
                this.setState({ progressBarPerc: 0, isAction: true });
                setTimeout(() => {
                    this.getAllImages();
                    this.setState({ isAction: false, message: 'Image has been uploaded', msgType: "success" });
                }, 2000);
            }
        }, 1000);
    }

    getRadioButtonStatus = (param) => {
        if(param === "import") {
            this.setState({
                showImageUrlBox: true,
                showImageUploadBox: false,
                uploadnameempty: false,
                uploadfileempty: false,
                containerempty: false,
                diskempty: false,
                radioButtonPlan: "import",
                files: "",
                fileName: "",
                fileSize: "",
                importImageUrl: "",
                importImageName: "",
                uploadImageName: "",
                uploadRegion: "",
                uploadContainerFormat: "",
                uploadDiskFormat: "",
                regionid: "",
                countryName: "",
                regionContainerFocus: false,
                regionempty: false,
                nameErrMessg: ''
            });

            $(".regionSelect_options").removeClass("active");
        }
        else if(param === "upload") {
            this.setState({
                showImageUrlBox: false,
                showImageUploadBox: true,
                radioButtonPlan: "upload",
                files: "",
                fileName: "",
                fileSize: "",
                importImageUrl: "",
                importImageName: "",
                uploadImageName: "",
                uploadRegion: "",
                uploadContainerFormat: "",
                uploadDiskFormat: "",
                regionid: "",
                countryName: "",
                regionContainerFocus: false,
                containerempty: false,
                diskempty: false,
                importnameempty: false,
                importurlempty: false,
                regionempty: false,
                nameErrMessg: ''
            });
            $(".regionSelect_options").removeClass("active");

        }
    };
    loadRegions = () => {
        RegionService.getAll().then((resp) => {
            if(resp === false) {
                this.setState({
                    regionListFilter: []
                });
            }
            this.setState({
                regionList: resp
            });
        });

    };
    getRegionDropdown = () => {
        $(".regionSelect_options").addClass("active");
        let regionListFilter = [...this.state.regionList];
        console.log(regionListFilter);
        console.log(this.state.copyImageRegion);
        regionListFilter = regionListFilter.filter(item => item.id !== this.state.copyImageRegion);
        console.log(regionListFilter);
        this.setState({
            regionListFilter: regionListFilter,
            uploadRegion: "",
            isregionselected: false
        });
    };
    filterDropDown = (event) => {
        $(".regionSelect_options").addClass("active");

        let name = event.target.name;
        let val = event.target.value;

        this.setState({
            regionListFilter: this.state.regionList.filter(item => item.name.toLowerCase().includes(val.toLowerCase())),
            uploadRegion: val

        });

    };

    getSelectedRegion = (event, regionOb) => {
        if(regionOb.status !== 1) {
            return;
        }
        $(".regionSelect_options").removeClass("active");
        this.setState({
            uploadRegion: regionOb.name,
            regionid: regionOb.id,
            isregionselected: true,
            countryName: regionOb.countryName,
            regionempty: false
        });

    };

    getAllImages = () => {
        ImageService.getAllImageDetailsById().then((resp) => {
            if(resp === false) {
                this.setState({
                    isAction: false,
                    message: "Error while fetching image Details, try again!",
                    msgType: "error"
                });
                return;
            }
            this.loadRegions();
            let backups = resp[0].filter(item => item.type === "backup");
            backups.sort(function (a, b) {
                return new Date(b.created) - new Date(a.created);
            });
            let imagesBackupsPaged = backups;
            if(backups.length > this.state.count) imagesBackupsPaged = backups.slice(0, this.state.count);
            let snapshot = resp[0].filter(item => item.type === "snapshot");
            snapshot.sort(function (a, b) {
                return new Date(b.created) - new Date(a.created);
            });
            let imageSnapshotsPaged = snapshot;
            if(snapshot.length > this.state.count) imageSnapshotsPaged = snapshot.slice(0, this.state.count);
            let custom = resp[0].filter(item => item.type !== "snapshot" && item.type !== "backup");
            custom.sort(function (a, b) {
                return new Date(b.created) - new Date(a.created);
            });

            let customImagesPaged = custom;
            if(custom.length > this.state.count) customImagesPaged = custom.slice(0, this.state.count);

            if(custom === undefined || custom === null) {
                return;
            }
            let status = true;
            custom.forEach(item => {
                // if(item.flav === undefined) item.flav = this.getFlavorDetailsById(item.flavor.id);
                let itemStatus = item.status.toLowerCase();
                if(itemStatus === 'active' || itemStatus === 'error' || itemStatus === 'queued') {
                    item.status = itemStatus;
                }
                else {
                    item.status = "pending";
                    status = false;
                }

            });
            if(status) {
                clearInterval(this.imagesListInterval);

            }

            this.setState({
                isAction: false,
                imagesBackups: backups,
                imageSnapshots: snapshot,
                customImages: custom,
                imagesBackupsPaged: imagesBackupsPaged,
                imageSnapshotsPaged: imageSnapshotsPaged,
                customImagesPaged: customImagesPaged,
                customIndexCount: 0
            }, () => this.activateActionMenu());

            //this.getFailureTaskStatus(backups, custom);
        });

    };

    getFailureTaskStatus(backups, custom) {
        let inactiveImages = [];
        backups.forEach(elem => {
            if(elem.status !== 'active') {
                inactiveImages.push({
                    "id": elem.id,
                    "region": elem.regionname
                });

            }
        });

        custom.forEach(elem => {
            if(elem.status !== 'active') {
                inactiveImages.push({
                    "id": elem.id,
                    "region": elem.regionname
                });

            }
        });

        ImageService.taskFailureStatus(inactiveImages).then(resp => {
            if(resp && Array.isArray(resp)) {
                let items = resp.filter(item => item.status === true);

                if(items.length > 0) {
                    items.forEach(item => {
                        let ob = backups.find(e => e.id === item.id);
                        if(ob === undefined) {
                            ob = custom.find(e => e.id === item.id);
                        }
                        if(ob !== undefined) {
                            ob.isTaskFailed = true;
                        }
                    });
                    this.setState({ imagesBackups: backups, customImages: custom });
                }

            }
        });
    }

    setProgressBar = (data) => {
        if(data === undefined || data === null) {
            return;
        }
        let status = true;
        data.forEach(item => {
            // if(item.flav === undefined) item.flav = this.getFlavorDetailsById(item.flavor.id);
            let itemStatus = item.status.toLowerCase();
            if(itemStatus === 'active' || item.taskState === 'error') {
                item.status = itemStatus;

            }
            else {
                item.status = "notactive";

                status = false;
            }

        });
        if(status) {
            clearInterval(sessionStorage.instanceListInterval);
        }
        return data;
    };

    activateActionMenu() {
        var documentwindowHeight = $(document).height();
        $('.dashboard_module .table_data .tr .row_menu_icon, .tabular_data_wrap li .menu_icon').click(function () {

            $('.tabular_data_wrap .table_data .tr').removeClass('row_selected');
            $(this).closest('.tr').addClass('row_selected');
            //$(this).closest('.dashboard_module .tr').find('.dropdown_component').toggleClass('row_selected');
            $(this).find('.dropdown_component').css({ top: '30px' });
            let fmi = 'dropdown_component';
            var offset = $(this).offset();
            var x = (offset.left);
            var y = (offset.top);
            var windowHeight = $(window).height();
            var menuHeight = $(this).find('.' + fmi).height();
            var totalHeight = menuHeight + y;
            // alert("totHeight:" + totalHeight);
            // alert("docwindowHeight:" + documentwindowHeight);
            //var tabHeight = $(this).parents(".table_data").height();
            //if(tabHeight <= 300){
            //$(this).parents(".table_data").addClass("padding-bottom");
            //}
            if((windowHeight <= 800) && (menuHeight <= 200)) {
                totalHeight = totalHeight + 50;
            }
            if(documentwindowHeight < totalHeight) {
                $('.' + fmi).css({ top: -Math.abs(menuHeight + 10) });
                $('.arrow_pointer').addClass('bottom_arrow');

                if(windowHeight < 800) {
                    //alert('test 1' + windowHeight)
                    totalHeight = totalHeight - windowHeight;
                    totalHeight = totalHeight - $(this).find('.dropdown_component').innerHeight();
                    totalHeight = totalHeight + 50;
                    //alert('1 condition'+totalHeight);
                    window.scrollTo({ top: totalHeight, behavior: 'smooth', });
                    $(this).find('.dropdown_component').css({ zIndex: '999' });
                }
            }
            else if(documentwindowHeight > totalHeight) { //alert('test 2')
                totalHeight = totalHeight - windowHeight;
                totalHeight = totalHeight + 50;
                $('.arrow_pointer').removeClass('bottom_arrow');

                window.scrollTo({ top: totalHeight, behavior: 'smooth', });
            }

        });

    }

    loadcss = () => {
        const link = document.createElement("link");
        link.href = "https://www.idrivecompute.com/webapp/css/images.css";
        link.rel = "stylesheet";
        link.type = "text/css";
        document
            .head
            .appendChild(link);
    };

    enableImageOptions = (event, param) => {
        //event.preventDefault()
        $(event.currentTarget).closest('.tr').find('.image_row_options').toggleClass('active');
        this.setState({
            imageid: param
        });
    };
    enableImageUpload = (event) => {
        this.setState({
            message: "",
            files: "",
            fileName: "",
            fileSize: "",
            radioButtonPlan: "upload",
            importImageUrl: "",
            uploadImageName: "",
            importImageName: "",
            uploadRegion: "",
            uploadContainerFormat: "",
            uploadDiskFormat: "",
            importnameempty: false,
            importurlempty: false,
            uploadnameempty: false,
            uploadfileempty: false,
            uploadfileerror: false,
            regionempty: false,
            containerempty: false,
            diskempty: false,
            regionid: "",
            countryName: "",
            showImageUploadBox: true,
            showImageUrlBox: false,
            regionContainerFocus: false,
            nameErrMessg: '',
            copyImageRegion: ""

        });
        $('.ImageModule_CustomImgUpload').addClass('active');
        $(".regionSelect_options").removeClass("active");

    };

    enableBackupEdit = (param) => {
        if(this.state.imagetype === "backups") {
            $(".ImageModule_editBackup").toggleClass("active");
        }
        else if(this.state.imagetype === "snapshot") {
            $(".ImageModule_editSnapshot").toggleClass("active");
        }
        else {
            $(".ImageModule_editCustom").toggleClass("active");
        }
        this.setState({
            message: "",
            editnameempty: false,
            nameErrMessg: '',
            editImageId: param[0],
            editImageRegion: param[1],
            editImageName: removeSpecialCharacter(param[2]),
            defaultEditImageName: removeSpecialCharacter(param[2])
        });
        setTimeout(() => {
            this.editnamefocus.current.focus();
        }, 100);
    };
    enableImageDelete = (param) => {

        this.setState({
            message: "",
            imagedeleteregion: param[0],
            imagedeleteid: param[1],
            imagedeletename: param[2]
        });
        $(".delete_image_popup").addClass("active");
        $("body").addClass("popup_no_scroll");

        document.getElementById("deleteImageFocus").focus();
    };

    imageType = (param) => {
        this.setState({
            imagetype: param[0]
        }, () => this.activateActionMenu());
    };

    handleInput = (event) => {
        let name = event.target.name;
        let val = event.target.value;
        var nameRegex = new RegExp("^[-a-zA-Z0-9]*$");

        this.setState({
            [name]: val
        });
        if(name === "editImageName") {
            if(val.length <= 0) {
                this.setState({
                    editnameempty: true,
                    nameErrMessg: ''
                });
            }
            else {
                if(!nameRegex.test(val)) {
                    this.setState({ nameErrMessg: 'Name can contain alphanumeric characters (a-z, A-Z, 0-9) and dashes (-)', editnameempty: false });
                } else {
                    this.setState({
                        editnameempty: false,
                        nameErrMessg: ''
                    });
                }
            }
        }
        if(name === "uploadImageName") {
            if(val.length <= 0) {
                this.setState({
                    uploadnameempty: true,
                    nameErrMessg: ''
                });
            }
            else {
                if(!nameRegex.test(val)) {
                    this.setState({ nameErrMessg: 'Name can contain alphanumeric characters (a-z, A-Z, 0-9) and dashes (-)', uploadnameempty: false });
                } else {
                    this.setState({
                        uploadnameempty: false,
                        nameErrMessg: ''

                    });
                }
            }
        }
        if(name === "importImageName") {
            if(val.length <= 0) {
                this.setState({
                    importnameempty: true,
                    nameErrMessg: ''
                });
            }
            else {
                if(!nameRegex.test(val)) {
                    this.setState({ nameErrMessg: 'Name can contain alphanumeric characters (a-z, A-Z, 0-9) and dashes (-)', importnameempty: false });
                } else {
                    this.setState({
                        importnameempty: false,
                        nameErrMessg: ''
                    });
                }
            }
        }
        if(name === "importImageUrl") {
            if(val.length <= 0) {
                this.setState({
                    importurlempty: true,
                    nameErrMessg: ''
                });
            }
            else {
                if(!nameRegex.test(val)) {
                    this.setState({ nameErrMessg: 'Name can contain alphanumeric characters (a-z, A-Z, 0-9) and dashes (-)', importurlempty: false });
                }
                this.setState({
                    importurlempty: false,
                    nameErrMessg: ''

                });
            }
        }
        if(name === "uploadContainerFormat") {
            if(val.length <= 0) {
                this.setState({
                    containerempty: true
                });
            }
            else {
                this.setState({
                    containerempty: false
                });
            }
        }
        if(name === "uploadDiskFormat") {
            if(val.length <= 0) {
                this.setState({
                    diskempty: true
                });
            }
            else {
                this.setState({
                    diskempty: false
                });
            }
        }

    };

    handleFile = (e) => {
        this.setState({
            uploadfileerror: false,
            uploadfileempty: false,
            uploadfileempty: ''
        });
        if(e.target.files.length > 0) {

            let file = e.target.files[0];
            let filename = file.name;
            let filesize = formatBytesFloat(file.size);
            let format = filename.split(".").pop();
            // if(format === "iso" || format === "vhdx" || format === "vhd" || format === "vmdk"){
            this.setState({
                files: file,
                fileName: filename,
                fileSize: filesize
                //uploadfileerror:false
            });

        }

    };

    createInstanceImage = (elem) => {
        this.props.history.push({
            pathname: "/create",
            state: {
                image: { ...elem },
                regionName: elem.regionname
            }
        });
    };

    editImage = () => {
        if(this.state.defaultEditImageName === this.state.editImageName.trim()) {
            this.setState({
                message: "No changes found to edit",
                msgType: "error"
            });
            return;
        }
        var nameRegex = new RegExp("^[-a-zA-Z0-9]*$");
        if(!nameRegex.test(this.state.editImageName)) {
            this.setState({ nameErrMessg: 'Name can contain alphanumeric characters (a-z, A-Z, 0-9) and dashes (-)' });
            this.editnamefocus.current.focus();
            return;
        }
        if(this.state.editImageName.trim().length <= 0) {
            this.setState({
                editnameempty: true
            });
            this.editnamefocus.current.focus();
            return;
        }
        else {
            this.setState({
                isAction: true,
                iseditButtonClick: true,
                nameErrMessg: ''
            });
            let editiamgelog = this.state.editImageName;
            let operation = "";
            if(this.state.imagetype === "backups") {
                operation = "Image Backup Rename";
            }
            else if(this.state.imagetype === "snapshot") {
                operation = "Image Snapshot Rename";
            }
            else {
                operation = "Custom Image Rename";
            }

            ImageService.editImage(this.state.editImageRegion, this.state.editImageId, this.state.editImageName).then((resp) => {
                if(resp === false) {
                    this.setState({
                        isAction: false,
                        message: "Failed to rename Image, Try again!",
                        msgType: "error",
                        iseditButtonClick: false
                    });
                    return;
                }
                this.setState({
                    editImageName: "",
                    message: "Image name has been changed",
                    msgType: "success",
                    iseditButtonClick: false
                });
                const sshbody = {
                    "userId": localStorage.getItem("userId"),
                    "name": this.state.defaultEditImageName + " has been changed to " + editiamgelog,
                    "operation": operation,
                    "region": this.state.editImageRegion
                };
                AuditLog.storeAuditLogs(sshbody, "instance").then((resp) => {
                    if(resp === false);
                });
                if(this.state.imagetype === "backups") {
                    $(".ImageModule_editBackup").removeClass("active");
                }
                else if(this.state.imagetype === "snapshot") {
                    $(".ImageModule_editSnapshot").removeClass("active");
                }
                else {
                    $(".ImageModule_editCustom").removeClass("active");
                }
                this.getAllImages();

            });
        }
    };

    downloadImage = (event, imageId, imageName, regionname) => {
        //console.log(regionname)
        let url = ImageService.downloadImageById(regionname, imageId, imageName);
        //console.log(url)
        loginService.tryRefresh().then(() => {
            window.location.href = url;
        }).catch(err => {
            return;
        });
    };

    deleteImage = () => {
        $(".delete_image_popup").removeClass("active");
        $("body").removeClass("popup_no_scroll");
        this.setState({
            isAction: true
        });
        let operation = "";
        if(this.state.imagetype === "backups") {
            operation = "Image Backup Deleted";
        }
        else if(this.state.imagetype === "snapshot") {
            operation = "Image Snapshot Deleted";
        }
        else {
            operation = "Custom Image Deleted";
        }
        let imageDelete = this.state.imagedeletename;
        ImageService.deleteImageByIdAndRegion(this.state.imagedeleteregion, this.state.imagedeleteid).then(resp => {

            if(resp === false) {
                this.setState({
                    isAction: false,
                    message: "Failed to delete Image, Try again!",
                    msgType: "error"
                });
                return;
            }
            const sshbody = {
                "userId": localStorage.getItem("userId"),
                "name": "image " + imageDelete + " has been deleted",
                "operation": operation,
                "region": this.state.imagedeleteregion
            };
            AuditLog.storeAuditLogs(sshbody, "instance").then((resp) => {
                if(resp === false);
            });
            this.setState({
                message: "Image Deleted Successfully",
                msgType: "success"
            });

            this.getAllImages();

        });
    };
    uploadImage = () => {
        var nameRegex = new RegExp("^[-a-zA-Z0-9]*$");
        this.setState({
            importnameempty: false,
            importurlempty: false,
            uploadnameempty: false,
            uploadfileempty: false,
            uploadfileerror: false,
            regionempty: false,
            nameErrMessg: ''
        });
        const requestBody =
        {
            "container_format": "bare",
            "disk_format": "raw",
            "name": this.state.showImageUrlBox ? this.state.importImageName.trim() : this.state.uploadImageName.trim(),
            "visibility": "private",
            "hw_qemu_guest_agent": "yes"
        };
        if(this.state.regionid.length <= 0) {
            this.setState({
                regionempty: true

            });
            this.uploadRegionFocus.current.focus();
            return;

        }

        else if(this.state.showImageUrlBox) {

            if(this.state.importImageUrl.trim().length <= 0) {

                this.setState({
                    importurlempty: true
                });
                this.importurlfocus.current.focus();
                return;

            }
            else if(this.state.importImageName.trim().length <= 0) {
                this.setState({
                    importnameempty: true,
                    nameErrMessg: ''
                });
                this.importnamefocus.current.focus();
                return;

            } else
                if(!nameRegex.test(this.state.importImageName.trim())) {
                    this.setState({ nameErrMessg: 'Name can contain alphanumeric characters (a-z, A-Z, 0-9) and dashes (-)', importnameempty: false });
                    this.importnamefocus.current.focus();
                }
                else {
                    this.loadUploadFunction(requestBody);
                }
        }
        else if(this.state.showImageUploadBox) {

            if(this.state.uploadImageName.trim().length <= 0) {
                this.setState({
                    uploadnameempty: true,
                    nameErrMessg: ''
                });
                this.uploadnamefocus.current.focus();
                return;
            } else
                if(!nameRegex.test(this.state.uploadImageName.trim())) {
                    this.setState({ nameErrMessg: 'Name can contain alphanumeric characters (a-z, A-Z, 0-9) and dashes (-)', uploadnameempty: false });
                    this.uploadnamefocus.current.focus();
                }
                else if(this.state.files === "") {
                    this.setState({
                        uploadfileempty: true,
                        nameErrMessg: ''

                    });
                    return;
                }
                else {
                    this.loadUploadFunction(requestBody);
                }
        }


    };
    loadUploadFunction = (requestBody) => {
        if(this.state.isUserSubscribed) {
            this.setState({
                isRedirectToCCPage: true
            });
        }
        else {
            this.setState({
                isAction: true
            });
            if(this.state.showImageUrlBox) {
                ImageService.uploadImage(this.state.regionid, requestBody).then((resp) => {

                    if(resp === false) {
                        this.setState({
                            isAction: false,
                            message: "Failed to upload image",
                            msgType: "error"
                        });
                        return;
                    }
                    let imageId = resp.data.id;

                    ImageService.importImageViaUrl(this.state.regionid, imageId, this.state.importImageUrl, requestBody.name).then((resp) => {

                        if(resp === false) {
                            this.setState({
                                isAction: false,
                                message: "Failed to import image",
                                msgType: "error"
                            });
                            return;
                        }
                        this.setState({
                            message: "Image has been imported and is in queued state. It will be ready for use soon.",
                            msgType: "success",
                            uploadImageName: "",
                            importImageName: "",
                            importImageUrl: "",
                            nameErrMessg: ''

                        });
                        $('.ImageModule_CustomImgUpload').removeClass("active");
                        this.getAllImages();

                    });
                });

            }
            if(this.state.showImageUploadBox) {
                this.setState({ isCloseActive: false, progressBarPerc: 0 });
                localStorage.setItem('uploadRegion', this.state.regionid);

                ImageService.uploadImageInclude(this.state.regionid, requestBody).then((resp) => {
                    const options = {
                        onUploadProgress: (ProgressEvent) => {
                            const { loaded, total } = ProgressEvent;
                            let percent = Math.floor((loaded * 100) / total);
                            if(percent === 0) {
                                percent = 1;
                            }
                            localStorage.setItem('progressBarPerc', percent);
                            if(percent === 100) {
                                this.setState({ isCloseActive: true, progressBarPerc: 0, isAction: true });
                                localStorage.removeItem('progressBarPerc');
                                setTimeout(() => {
                                    this.getAllImages();
                                    this.setState({ isAction: false, message: "Image has been uploaded", msgType: "success" });
                                }, 10000);
                                //$(".upload_image_popup").removeClass("active")
                                return;
                            }
                            this.setState({ progressBarPerc: percent, isAction: false });
                        },
                        cancelToken: new CancelToken(cancel => this.setState({ cancelToken: cancel }))
                    };
                    this.openUploadImage();
                    this.setState({ isCloseActive: false, progressBarPerc: 0 });

                    ImageService.uploadBinaryImageLocal(resp.uri, resp.temp, this.state.files, options).then((response) => {
                        if(response === false) {
                            this.setState({
                                isAction: false,
                                message: "Failed to upload image",
                                msgType: "error"

                            });
                            $('.ImageModule_CustomImgUpload').removeClass("active");
                            return;
                        }
                        if(this.state.isCancelled) {
                            return;
                        }

                        this.setState({
                            message: "Image has been uploaded and is in queued state. It will be ready for use soon.",
                            msgType: "success",
                            isAction: false,
                            uploadImageName: "",
                            importImageName: "",
                            importImageUrl: "",
                            nameErrMessg: ''
                        });

                        localStorage.removeItem("isUpload");
                        this.getAllImages();
                    });
                });

                // ImageService.uploadImageBinaryData(this.state.regionid,this.state.files,options,requestBody).then((res)=>{
                // })

            }

        }

    };


    headerSortClick = (event) => {
        $('.sort_icon').removeClass('active');
        $(event.currentTarget).find('.sort_icon').addClass('active');
        $(event.currentTarget).find('.sort_icon').toggleClass('toggle_sort');
    };

    setSortable = (params) => {

        if(params[0] === "backup") {
            let items = [...this.state.imagesBackups];
            if(params[1] === "name") {
                if(this.state.backupNameToggle) {
                    items.sort(function (a, b) {
                        if(a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
                        if(a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
                        return 0;
                    });
                }
                else {
                    items.sort(function (a, b) {
                        if(a.name.toLowerCase() < b.name.toLowerCase()) { return 1; }
                        if(a.name.toLowerCase() > b.name.toLowerCase()) { return -1; }
                        return 0;
                    });
                }
                this.setState({
                    backupNameToggle: !this.state.backupNameToggle,
                    backupSizeToggle: false,
                    backupRegionToggle: false,
                    backupDateToggle: false,
                });
            }
            else if(params[1] === "size") {
                if(this.state.backupSizeToggle) {
                    items.sort(function (a, b) {
                        if(a.size < b.size) { return 1; }
                        if(a.size > b.size) { return -1; }
                        return 0;
                    });
                }
                else {
                    items.sort(function (a, b) {
                        if(a.size < b.size) { return -1; }
                        if(a.size > b.size) { return 1; }
                        return 0;
                    });
                }
                this.setState({
                    backupSizeToggle: !this.state.backupSizeToggle,
                    backupNameToggle: false,
                    backupRegionToggle: false,
                    backupDateToggle: false,
                });
            }
            else if(params[1] === "region") {
                if(this.state.backupRegionToggle) {
                    items.sort(function (a, b) {
                        if(a.fullRegion < b.fullRegion) { return 1; }
                        if(a.fullRegion > b.fullRegion) { return -1; }
                        return 0;
                    });
                }
                else {
                    items.sort(function (a, b) {
                        if(a.fullRegion < b.fullRegion) { return -1; }
                        if(a.fullRegion > b.fullRegion) { return 1; }
                        return 0;
                    });

                }
                this.setState({
                    backupRegionToggle: !this.state.backupRegionToggle,
                    backupNameToggle: false,
                    backupSizeToggle: false,
                    backupDateToggle: false,
                });
            }
            else if(params[1] === "date") {
                if(this.state.backupDateToggle) {
                    items.sort(function (a, b) {
                        return new Date(b.created) - new Date(a.created);
                    });
                }
                else {

                    items.sort(function (a, b) {
                        return new Date(a.created) - new Date(b.created);
                    });
                }
                this.setState({
                    backupDateToggle: !this.state.backupDateToggle,
                    backupNameToggle: false,
                    backupSizeToggle: false,
                    backupRegionToggle: false,
                });
            } else if(params[1] === "status") {
                if(this.state.backupStatusToggle) {
                    items.sort(function (a, b) {
                        if(a.status < b.status) { return 1; }
                        if(a.status > b.status) { return -1; }
                        return 0;
                    });
                }
                else {
                    items.sort(function (a, b) {
                        if(a.status < b.status) { return -1; }
                        if(a.status > b.status) { return 1; }
                        return 0;
                    });
                }
                this.setState({
                    backupStatusToggle: false,
                    backupDateToggle: false,
                    backupNameToggle: false,
                    backupSizeToggle: false,
                    backupRegionToggle: false,
                });
            }
            let imagesBackupsPaged = items;
            if(items.length > this.state.count) imagesBackupsPaged = imagesBackupsPaged.slice(0, this.state.count);
            this.setState({
                imagesBackups: items,
                imagesBackupsPaged: imagesBackupsPaged, backupIndexCount: 0
            });
        }
        else if(params[0] === "snapshot") {
            let items = [...this.state.imageSnapshots];
            if(params[1] === "name") {
                if(this.state.snapshotNameToggle) {
                    items.sort(function (a, b) {
                        if(a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
                        if(a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
                        return 0;
                    });
                }
                else {
                    items.sort(function (a, b) {
                        if(a.name.toLowerCase() < b.name.toLowerCase()) { return 1; }
                        if(a.name.toLowerCase() > b.name.toLowerCase()) { return -1; }
                        return 0;
                    });
                }
                this.setState({
                    snapshotNameToggle: !this.state.snapshotNameToggle,
                    snapshotSizeToggle: false,
                    snapshotRegionToggle: false,
                    snapshotDateToggle: false,
                });
            }
            else if(params[1] === "size") {
                if(this.state.snapshotSizeToggle) {
                    items.sort(function (a, b) {
                        if(a.size < b.size) { return 1; }
                        if(a.size > b.size) { return -1; }
                        return 0;
                    });
                }
                else {
                    items.sort(function (a, b) {
                        if(a.size < b.size) { return -1; }
                        if(a.size > b.size) { return 1; }
                        return 0;
                    });
                }
                this.setState({
                    snapshotSizeToggle: !this.state.snapshotSizeToggle,
                    snapshotNameToggle: false,
                    snapshotRegionToggle: false,
                    snapshotDateToggle: false,
                });
            }
            else if(params[1] === "region") {
                if(this.state.snapshotRegionToggle) {
                    items.sort(function (a, b) {
                        if(a.fullRegion < b.fullRegion) { return 1; }
                        if(a.fullRegion > b.fullRegion) { return -1; }
                        return 0;
                    });
                }
                else {
                    items.sort(function (a, b) {
                        if(a.fullRegion < b.fullRegion) { return -1; }
                        if(a.fullRegion > b.fullRegion) { return 1; }
                        return 0;
                    });
                }
                this.setState({
                    snapshotRegionToggle: !this.state.snapshotRegionToggle,
                    snapshotNameToggle: false,
                    snapshotSizeToggle: false,
                    snapshotDateToggle: false,
                });
            }
            else if(params[1] === "date") {
                if(this.state.snapshotDateToggle) {
                    items.sort(function (a, b) {
                        return new Date(b.created) - new Date(a.created);
                    });
                }
                else {
                    items.sort(function (a, b) {
                        return new Date(a.created) - new Date(b.created);
                    });

                }
                this.setState({
                    snapshotDateToggle: !this.state.snapshotDateToggle,
                    snapshotNameToggle: false,
                    snapshotSizeToggle: false,
                    snapshotRegionToggle: false
                });
            } else if(params[1] === "status") {
                if(this.state.snapshotStatusToggle) {
                    items.sort(function (a, b) {
                        if(a.status < b.status) { return 1; }
                        if(a.status > b.status) { return -1; }
                        return 0;
                    });
                }
                else {
                    items.sort(function (a, b) {
                        if(a.status < b.status) { return -1; }
                        if(a.status > b.status) { return 1; }
                        return 0;
                    });
                }
                this.setState({
                    snapshotStatusToggle: !this.state.snapshotStatusToggle,
                    snapshotDateToggle: false,
                    snapshotNameToggle: false,
                    snapshotSizeToggle: false,
                    snapshotRegionToggle: false
                });
            }

            let imageSnapshotsPaged = items;
            if(items.length > this.state.count) imageSnapshotsPaged = imageSnapshotsPaged.slice(0, this.state.count);
            this.setState({ imageSnapshotsPaged: imageSnapshotsPaged, imageSnapshots: items, snapIndexCount: 0 });
        }
        else if(params[0] === "custom") {
            let items = [...this.state.customImages];
            if(params[1] === "name") {
                if(this.state.customNameToggle) {
                    items.sort(function (a, b) {
                        if(a.name.toLowerCase() < b.name.toLowerCase()) { return 1; }
                        if(a.name.toLowerCase() > b.name.toLowerCase()) { return -1; }
                        return 0;
                    });
                }
                else {
                    items.sort(function (a, b) {
                        if(a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
                        if(a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
                        return 0;
                    });
                }
                this.setState({
                    customNameToggle: !this.state.customNameToggle,
                    customSizeToggle: false,
                    customRegionToggle: false,
                    customDateToggle: false,
                    customStatusToggle: false,
                });
            }
            else if(params[1] === "size") {
                if(this.state.customSizeToggle) {
                    items.sort(function (a, b) {
                        if(a.size < b.size) { return 1; }
                        if(a.size > b.size) { return -1; }
                        return 0;
                    });
                }
                else {
                    items.sort(function (a, b) {
                        if(a.size < b.size) { return -1; }
                        if(a.size > b.size) { return 1; }
                        return 0;
                    });
                }
                this.setState({
                    customSizeToggle: !this.state.customSizeToggle,
                    customNameToggle: false,
                    customRegionToggle: false,
                    customDateToggle: false,
                    customStatusToggle: false,
                });
            }
            else if(params[1] === "status") {
                if(this.state.customStatusToggle) {
                    items.sort(function (a, b) {
                        if(a.status < b.status) { return 1; }
                        if(a.status > b.status) { return -1; }
                        return 0;
                    });
                }
                else {
                    items.sort(function (a, b) {
                        if(a.status < b.status) { return -1; }
                        if(a.status > b.status) { return 1; }
                        return 0;
                    });
                }
                this.setState({
                    customStatusToggle: !this.state.customStatusToggle,
                    customNameToggle: false,
                    customSizeToggle: false,
                    customRegionToggle: false,
                    customDateToggle: false
                });
            }
            else if(params[1] === "region") {
                if(this.state.customRegionToggle) {
                    items.sort(function (a, b) {
                        if(a.fullRegion < b.fullRegion) { return 1; }
                        if(a.fullRegion > b.fullRegion) { return -1; }
                        return 0;
                    });
                }
                else {
                    items.sort(function (a, b) {
                        if(a.fullRegion < b.fullRegion) { return -1; }
                        if(a.fullRegion > b.fullRegion) { return 1; }
                        return 0;
                    });

                }
                this.setState({
                    customRegionToggle: !this.state.customRegionToggle,
                    customNameToggle: false,
                    customSizeToggle: false,
                    customDateToggle: false,
                    customStatusToggle: false,
                });
            }
            else if(params[1] === "date") {
                if(this.state.customDateToggle) {
                    items.sort(function (a, b) {
                        return new Date(b.created) - new Date(a.created);
                    });
                }
                else {
                    items.sort(function (a, b) {
                        return new Date(a.created) - new Date(b.created);
                    });
                }
                this.setState({
                    customDateToggle: !this.state.customDateToggle,
                    customNameToggle: false,
                    customSizeToggle: false,
                    customRegionToggle: false,
                    customStatusToggle: false,
                });
            }
            let customImagesPaged = items;
            if(items.length > this.state.count) customImagesPaged = customImagesPaged.slice(0, this.state.count);
            this.setState({
                customImages: items,
                customImagesPaged: customImagesPaged,
                customIndexCount: 0
            });
        }
    };

    openCancelConfirmPoup() {
        $(".upload_image_popup").addClass("active");
        document.getElementById('uploadcancel').focus();
    }

    copyToRegion = (id, region, name) => {
        $(".regionSelect_options").removeClass("active");
        this.setState({
            isAddRegSlider: true,
            copyImageId: id,
            copyImageRegion: region,
            copyImageName: name,
            uploadRegion: "",
            regionid: "",
            countryName: "",
            regionempty: false
        });
    };
    callCopyRegion = () => {
        if(this.state.regionid.length <= 0) {
            this.setState({
                regionempty: true
            });
            return;
        }
        this.setState({
            isCopyLoader: true,
            isAddRegSlider: false
        });
        ImageService.copyImageToReg(this.state.copyImageId, this.state.copyImageRegion, this.state.regionid, this.state.copyImageName)
            .then(resp => {
                if(resp === false) {
                    this.setState({
                        isCopyLoader: false,
                        message: "Image copy intiation failed, please try after some time.",
                        msgType: "error"
                    });
                    return;
                }
                this.getAllImages();
                this.getCopyImageData();
                setTimeout(() => {
                    clearInterval(this.imagesListInterval);
                    clearInterval(this.imagesIdData);
                    if(resp == "COPY INITIATED") {
                        this.imagesListInterval = setInterval(() => this.getAllImages(), 20000);
                        this.imagesIdData = setInterval(() => this.getCopyImageData(), 20000);
                    }

                    this.setState({
                        isCopyLoader: false,
                        message: "Copying image from region " + this.state.copyImageRegion + " to " + this.state.regionid + " and it will be available under custom images",
                        msgType: "success"
                    });
                    setTimeout(() => {
                        this.setState({

                            message: "",
                            msgType: ""
                        });
                    }, 10000);
                }, 4000);

            })
            .catch(error => {
                console.log(error);
            });
    };

    getCopyImageData = () => {
        ImageService.getCopyImages().then(resp => {

            let data = Object.keys(resp);
            if(data.length <= 0) {
                clearInterval(this.imagesIdData);
            }
            this.setState({
                copyImages: data
            });
        }).catch(err => {
            console.log(err);
        });
    };

    handleBackupNextClick = (event) => {
        let imagesBackups = this.state.imagesBackups;
        let backupIndexCount = this.state.backupIndexCount + this.state.count;
        let endCount = backupIndexCount + this.state.count;
        if(endCount > imagesBackups.length) endCount = imagesBackups.length;
        this.setState({
            backupIndexCount: backupIndexCount,
            imagesBackupsPaged: imagesBackups.slice(backupIndexCount, endCount)
        });
        event.preventDefault();
    };

    handleBackupPreviousClick = (event) => {
        let imagesBackups = this.state.imagesBackups;
        let backupIndexCount = this.state.backupIndexCount - this.state.count;
        this.setState({
            backupIndexCount: this.state.backupIndexCount - this.state.count,
            imagesBackupsPaged: imagesBackups.slice(backupIndexCount, this.state.backupIndexCount)
        });
        event.preventDefault();
    };

    handleSnapNextClick = (event) => {
        let imageSnapshots = this.state.imageSnapshots;
        let snapIndexCount = this.state.snapIndexCount + this.state.count;
        let endCount = snapIndexCount + this.state.count;
        if(endCount > imageSnapshots.length) endCount = imageSnapshots.length;
        this.setState({
            snapIndexCount: snapIndexCount,
            imageSnapshotsPaged: imageSnapshots.slice(snapIndexCount, endCount)
        });
        event.preventDefault();
    };

    handleSnapPreviousClick = (event) => {
        let imageSnapshots = this.state.imageSnapshots;
        let snapIndexCount = this.state.snapIndexCount - this.state.count;
        this.setState({
            snapIndexCount: this.state.snapIndexCount - this.state.count,
            imageSnapshotsPaged: imageSnapshots.slice(snapIndexCount, this.state.snapIndexCount)
        });
        event.preventDefault();
    };

    handleCustomNextClick = (event) => {
        let customImages = this.state.customImages;
        let customIndexCount = this.state.snapIndexCount + this.state.count;
        let endCount = customIndexCount + this.state.count;
        if(endCount > customImages.length) endCount = customImages.length;
        this.setState({
            customIndexCount: customIndexCount,
            customImagesPaged: customImages.slice(customIndexCount, endCount)
        });
        event.preventDefault();
    };

    handleCustomPreviousClick = (event) => {
        let customImages = this.state.customImages;
        let customIndexCount = this.state.customIndexCount - this.state.count;
        this.setState({
            customIndexCount: this.state.customIndexCount - this.state.count,
            customImagesPaged: customImages.slice(customIndexCount, this.state.customIndexCount)
        });
        event.preventDefault();
    };

    render() {
        if(this.state.isRedirectToCCPage) {
            return <Redirect to={ {
                pathname: "/billing/creditcard",
                state: { message: true }
            } }></Redirect>;
        }
        const backupCss = `
        .stb{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}
       `;
        const customCss = `
        .st0{display:none;}
        .st1{display:inline;fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}
        .st2{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}
       `;

        const snapCss = `
       .sts{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}
       `;
        return (

            <body className={ this.state.imagetype === "backups" ? this.state.isRegionStatus && this.state.regionCount > 0 && this.state.isCluster == "show" ? "main_nav_module images_main_module imgMainModule_backup important_msg" : "main_nav_module images_main_module imgMainModule_backup" : this.state.imagetype === "snapshot" ?
                this.state.isRegionStatus && this.state.regionCount > 0 && this.state.isCluster == "show" ? "main_nav_module images_main_module imgMainModule_snapshot important_msg" : "main_nav_module images_main_module imgMainModule_snapshot" :
                this.state.isRegionStatus && this.state.regionCount > 0 && this.state.isCluster == "show" ? "main_nav_module images_main_module imgMainModule_customImg important_msg" : "main_nav_module images_main_module imgMainModule_customImg" }>
                <main>
                    <div className="full_page_loader" style={ { display: this.state.isAction ? 'block' : 'none' } }>
                        <div className="loader_icon"></div>
                    </div>
                    <div className="full_page_loader" style={ { display: this.state.isCopyLoader ? 'block' : 'none' } }>
                        <div className="loader_icon"></div>
                    </div>
                    <div className="common_user_message cluster_msg cluster_uiNew" style={ { display: this.state.isRegionStatus && this.state.regionCount > 0 && this.state.isCluster == "show" ? "" : "none" } }>
                        <div className="message_content">
                            { this.state.regionCount == 1 ?
                                <p><span className="cm_title">Region <b>{ this.state.regionString }</b> is under maintenance.  </span>
                                    You will not be able to create resources e.g. instances, volumes, etc., in this region and the existing resources may also become inaccessible during this period. We are trying to resolve this at the earliest. Thank you for your patience.
                                    <a href="https://status.idrivecompute.com/" target="_blank" className="check-status-btn">Check Status</a>
                                </p>
                                :
                                <p><span className="cm_title">Regions <b>{ this.state.regionString }</b> are under maintenance.  </span>
                                    You will not be able to create resources e.g. instances, volumes, etc., in this region and the existing resources may also become inaccessible during this period. We are trying to resolve this at the earliest. Thank you for your patience.
                                    <a href="https://status.idrivecompute.com/" target="_blank" className="check-status-btn">Check Status</a>
                                </p>
                            }
                            <span className="close_icon" data-tip data-for="closeCluster" onClick={ () => { this.setState({ isRegionStatus: false }); localStorage.setItem("clusterMessage", "hide"); } }></span>
                            <ReactToolTip id="closeCluster" place="left" effect="solid">Close</ReactToolTip>
                        </div>
                    </div>
                    <LeftNav isActive={ 'images' }></LeftNav>

                    <div className="main_container">
                        <header className="header_wrap">
                            <HeaderTop showCreate={ true } isUserSubscribed={ this.state.isUserSubscribed }></HeaderTop>
                            <div className="header_wrap_bottom">
                                <div className="bottom_navbar">
                                    <div className="bn_left">
                                        <div className="computer_no">
                                            <span className="text bold_600">Images</span>
                                        </div>
                                    </div>

                                    <div className="bn_right">
                                        <div className="rhs_info">
                                            { this.state.imagetype === "backups" ? <p>Number of Backups : { this.state.imagesBackups.length < 10 && this.state.imagesBackups.length !== 0 ? "0" + this.state.imagesBackups.length : this.state.imagesBackups.length }</p>
                                                : this.state.imagetype === "snapshot" ? <p>Number of Snapshots : { this.state.imageSnapshots.length < 10 && this.state.imageSnapshots.length !== 0 ? "0" + this.state.imageSnapshots.length : this.state.imageSnapshots.length }</p>
                                                    : <p>Number of custom images : { this.state.customImages.length < 10 && this.state.customImages.length !== 0 ? "0" + this.state.customImages.length : this.state.customImages.length }</p> }

                                        </div>
                                        { this.state.imagetype === "custom" ?
                                            <div className="cta_wrap">
                                                <input type="button" style={ { display: "none" } } name="" value="Import via URL" className="common_cta_btn transparentBlue_bg import_cta" onClick={ () => {
                                                    this.setState({
                                                        enableimageurl: !this.state.enableimageurl
                                                    });
                                                } }></input>
                                                <input type="button" name="" data-tip data-for="uploadimage" value="Upload Image" className={ this.state.progressBarPerc > 0 ? "common_cta_btn blue uploadImg_cta disabled" : "common_cta_btn blue uploadImg_cta" } onClick={ (e) => this.enableImageUpload(e) } disabled={ this.state.progressBarPerc > 0 ? true : false }></input>
                                                <ReactToolTip id="uploadimage" multiline={ true } effect="solid" place="left">Upload an image from hard disk or<br></br> import via URL for creating a new instance</ReactToolTip>
                                                <div className="boot_container " style={ { display: this.state.progressBarPerc === 0 ? 'none' : '' } }>
                                                    <div className="boot_wrapper">
                                                        <div className="progress_wrap">
                                                            <div className="title_head"><span className="head_title">Uploading</span><span className="percent_num">{ this.state.progressBarPerc }%</span></div>
                                                            <div className="progress_bar"><span className="percent_progress" style={ { width: this.state.progressBarPerc + '%' } }></span></div>
                                                        </div>
                                                    </div>
                                                    <a href="javascript:;" className="view_uploadDet" style={ { color: 'red' } } onClick={ this.openCancelConfirmPoup }>Cancel upload</a>
                                                </div>
                                            </div> : "" }
                                    </div>
                                </div>
                            </div>
                        </header>
                        <NotificationSlider />
                        { this.state.imagetype === "backups" ?
                            <section className="main_section pagination__wrap">
                                <div className="main_body_container">
                                    <div className="mainBody_colWrap">
                                        <div className="images_container">
                                            <div className="imageMain_table">
                                                <div className="image_tab_wrap">
                                                    <div className="custom_tabs_wrap">
                                                        <ul>
                                                            <li className={ this.state.imagetype === "backups" ? "active" : "" } onClick={ () => this.imageType(["backups"]) }>Backups</li>
                                                            <li className={ this.state.imagetype === "snapshot" ? "active" : "" } onClick={ () => this.imageType(["snapshot"]) }>Snapshots</li>
                                                            <li className={ this.state.imagetype === "custom" ? "active" : "" } onClick={ () => this.imageType(["custom"]) }>Custom Images</li>
                                                        </ul>
                                                    </div>
                                                </div>
                                                <div className={ this.state.imagetype === "backups" ?
                                                    'imgTabContent imageBckTab_content active' : 'imgTabContent imageBckTab_content' }>
                                                    <div className="Image_head_info">
                                                        <p>Manage image backups, snapshots, and custom images of your compute instances. Edit, delete, download, or use the images to create new instances</p>

                                                    </div>
                                                    <div className="tabular_data_wrap sixColumns">
                                                        <div className="table_header">
                                                            <ul>
                                                                <li className="th">
                                                                    <div className="col col1">
                                                                        <div className="header_sort_wrap" onClick={ (event) => { this.headerSortClick(event); this.setSortable(["backup", "name"]); } }>Name<span className="sort_icon "></span></div>
                                                                    </div>
                                                                    <div className="col col2">
                                                                        <div className="header_sort_wrap" onClick={ (event) => { this.headerSortClick(event); this.setSortable(["backup", "size"]); } }>Size<span className="sort_icon"></span></div>
                                                                    </div>
                                                                    <div className="col colStatus">
                                                                        <div className="header_sort_wrap" onClick={ (event) => { this.headerSortClick(event); this.setSortable(["backup", "status"]); } }>Status<span className="sort_icon"></span></div>
                                                                    </div>
                                                                    <div className="col col3">
                                                                        <div className="header_sort_wrap" onClick={ (event) => { this.headerSortClick(event); this.setSortable(["backup", "region"]); } }>Region<span className="sort_icon"></span></div>
                                                                    </div>
                                                                    <div className="col col4">
                                                                        <div className="header_sort_wrap" onClick={ (event) => { this.headerSortClick(event); this.setSortable(["backup", "date"]); } }>Created On<span className="sort_icon active"></span></div>
                                                                    </div>
                                                                    <div className="col col5"> Actions</div>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                        <div className="table_data">
                                                            { this.state.imagesBackups.length <= 0 && !this.state.isAction ?
                                                                <ul>
                                                                    <li>
                                                                        <div className="outer_empty_wrap fullPageEmpty">
                                                                            <div className="inner_empty_wrap">
                                                                                <div className="svg_wrap empty_icon backup_empty"></div>
                                                                                <p className="empty_head">Backups</p>
                                                                                <p className="empty_title">Enable backup of your compute instances to ensure their safety and for new instance creation.</p>
                                                                                <div className="btn_wrap_icon"></div>

                                                                            </div>
                                                                        </div>
                                                                    </li>
                                                                </ul>
                                                                :
                                                                <ul>
                                                                    { this.state.imagesBackupsPaged.map((image, index) =>
                                                                        <li className={ image.size !== null ? "tr" : "tr progress_tr" } key={ index }>
                                                                            <div className='table_col_wrap'>
                                                                                <div className="col col1">
                                                                                    <div className="name_icon">
                                                                                        <span className="svg_wrap backup">
                                                                                            <svg x="0px" y="0px"
                                                                                                viewBox="0 0 192 192" style={ { enableBackground: 'new 0 0 192 192' } } xmlSpace="preserve">
                                                                                                <style type="text/css">{ backupCss }</style>
                                                                                                <g>
                                                                                                    <path className="stb" d="M24.7,51.6c8.1,12.3,31,21.1,58.1,21.1c26.9,0,49.8-8.8,58-20.9V47h0c0-0.1,0-0.2,0-0.3
			                                                                        c0-12.9-26-23.4-58-23.4s-58,10.5-58,23.4c0,0.1,0,0.2,0,0.3h0V51.6z"/>
                                                                                                    <path className="stb" d="M94.3,125.7c-3.7,0.4-7.5,0.5-11.5,0.5c-27.1,0-50-8.9-58.1-21.1V137h0c0.2,12.9,26.1,23.3,58,23.3
			                                                                        c9.6,0,18.6-0.9,26.6-2.6C100.3,149.9,94.5,138.5,94.3,125.7z"/>
                                                                                                    <path className="stb" d="M137.2,82c1.2,0,2.4,0.1,3.6,0.2V61.3c-8.2,12.2-31.1,20.9-58,20.9c-27.1,0-50-8.9-58.1-21.1v34.5
			                                                                        c8.1,12.3,31,21.1,58.1,21.1c4.2,0,8.4-0.2,12.4-0.6C99.3,96.7,116.5,82,137.2,82z"/>
                                                                                                    <path className="stb" d="M137.1,88.5c-20.4,0-37,16.6-37,37c0,20.4,16.6,37,37,37c20.4,0,37-16.6,37-37
			                                                                        C174.1,105.1,157.6,88.5,137.1,88.5z M144.6,125.3v23.4h-14.9v-23.4h-15.5l23-23l23,23H144.6z"/>
                                                                                                </g>
                                                                                            </svg>
                                                                                        </span>
                                                                                    </div>
                                                                                    <div className="row_wrap"> <span className="row row_head" onMouseOver={ (e) => this.showToolTip(e, image.name) } data-tip data-for={ image.name }>{ image.name }</span>
                                                                                        { this.state.getTooltip ?
                                                                                            <ReactToolTip id={ image.name } effect="solid">{ image.name }</ReactToolTip> : ""
                                                                                        }
                                                                                        <span className="row row_info">{ image.name_info }</span> </div>
                                                                                </div>
                                                                                { image.size !== null ?
                                                                                    <div className="col col2">{ formatBytesFloat(image.size) }</div>
                                                                                    : <div className="col col2">Processing...</div> }
                                                                                <div className="col colStatus"> { image.status } </div>
                                                                                <div className="col col3"> { image.fullRegion } </div>
                                                                                <div className="col col4">{ image.created }</div>
                                                                                { image.size !== null && <div className="col col5"><span className="menu_icon" onClick={ (e) => this.enableImageOptions(
                                                                                    e, image.id
                                                                                ) }><span className="svg_wrap"><svg className="horizMenuIcon" data-tip data-for="actions" x="0px" y="0px" viewBox="0 0 22.1 6.3" enableBackground="new 0 0 22.1 6.3" xmlSpace="preserve">
                                                                                    <path fillRule="evenodd" clipRule="evenodd" fill="#8692B0" d="M19,5.7c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5  S20.4,5.7,19,5.7z M11,5.7c-1.4,0-2.5-1.1-2.5-2.5S9.6,0.7,11,0.7s2.5,1.1,2.5,2.5S12.4,5.7,11,5.7z M3,5.7c-1.4,0-2.5-1.1-2.5-2.5  S1.6,0.7,3,0.7s2.5,1.1,2.5,2.5S4.4,5.7,3,5.7z"></path>
                                                                                </svg><ReactToolTip id="actions" place="top" effect="solid">Actions</ReactToolTip></span>
                                                                                    <ul className="dropdown_component image_row_options">
                                                                                        <span className="arrow_pointer"></span>

                                                                                        { image.size !== null && <li className="instance_create" style={ { display: getReturn(this.state.regionMaintList, image.regionname) || (this.state.regionList && !this.state.regionList.find(elem => elem.id === image.regionname)) ? "none" : "" } } onClick={ () => this.createInstanceImage(image) }><span className="icon"> <span className="svg_wrap"><svg x="0px" y="0px" viewBox="0 0 512 512" enableBackground="new 0 0 512 512" xmlSpace="preserve">
                                                                                            <path fillRule="evenodd" clipRule="evenodd" fill="#4C8CCD" d="M448.8,287.9H288.5v160.3c0,17.7-14.4,32.1-32.1,32.1l0,0  c-17.7,0-32.1-14.4-32.1-32.1V287.9H64.1c-17.7,0-32.1-14.4-32.1-32.1s14.4-32.1,32.1-32.1h160.3V63.5c0-17.7,14.4-32.1,32.1-32.1  l0,0c17.7,0,32.1,14.4,32.1,32.1v160.3h160.3c17.7,0,32.1,14.4,32.1,32.1S466.5,287.9,448.8,287.9z"></path>
                                                                                        </svg></span></span>Create an instance</li> }
                                                                                        { image.size !== null && <li className="regionSlider" onClick={ () => this.copyToRegion(
                                                                                            image.id, image.regionname, image.name
                                                                                        ) }>
                                                                                            <span className="icon">
                                                                                                <span className="svg_wrap">
                                                                                                    <svg x="0px" y="0px" viewBox="0 0 22.7 22.7" enableBackground="new 0 0 22.7 22.7" xmlSpace="preserve">
                                                                                                        <g>
                                                                                                            <path className="rn0" d="M17.9,8.2c0,1.5-0.5,2.8-1.3,3.9l-5,8.9c-0.1,0.2-0.4,0.2-0.5,0l-5-8.9c-0.8-1.1-1.3-2.4-1.3-3.9
                                                                                                                c0-3.9,3.4-7,7.4-6.5C15.5,2,17.9,4.8,17.9,8.2z"></path>
                                                                                                            <circle className="rn0" cx="11.3" cy="8" r="2.6"></circle>
                                                                                                        </g>
                                                                                                    </svg>
                                                                                                </span>
                                                                                            </span>Add to Region
                                                                                        </li> }
                                                                                        { image.size !== null && <li className="edit" onClick={ () => this.enableBackupEdit([
                                                                                            image.id, image.regionname, image.name
                                                                                        ]) }><span className="icon"> <span className="svg_wrap"><svg x="0px" y="0px" width="19.6px" height="16.5px" viewBox="0 0 19.6 16.5" enableBackground="new 0 0 19.6 16.5" xmlSpace="preserve">
                                                                                            <path fillRule="evenodd" clipRule="evenodd" fill="#909AAA" d="M16.2,5.5l-0.7,0.7l-0.7,0.7l-6.2,6.8h5.2c0.6,0,1,0.4,1,1  s-0.4,1-1,1h-10l0,0h-1v-4l7.8-9L11.3,2L12,1.3c0.8-0.8,2-0.8,2.8,0l1.4,1.4C17,3.5,17,4.8,16.2,5.5z M11.7,4.5L5.1,12  c-0.4,0.4-0.4,1,0,1.4c0.4,0.4,1,0.4,1.4,0l6.6-7.6L11.7,4.5z"></path>
                                                                                        </svg></span></span>Edit</li> }
                                                                                        { image.size !== null && <li className="download" onClick={ (e) => this.downloadImage(e, image.id, image.name, image.regionname) }><span className="icon"> <span className="svg_wrap"><svg x="0px" y="0px" viewBox="0 0 512 512" enableBackground="new 0 0 512 512" xmlSpace="preserve">
                                                                                            <path fillRule="evenodd" clipRule="evenodd" fill="#4C8CCD" d="M417.2,470.3H95.6c-29.6,0-53.6-24-53.6-53.6v-80.4h53.6v80.4  h321.6v-80.4h53.6v80.4C470.8,446.3,446.8,470.3,417.2,470.3z M278.6,354.2c-3.4,3.4-7.5,5.4-11.8,6.8c-3.2,1.4-6.8,2.1-10.5,2.1  c-0.9,0-1.6-0.3-2.5-0.4c0,0-0.1,0-0.1,0c-2.2-0.2-4.4-0.5-6.4-1.3c-5.1-1.2-10.1-3.2-14.1-7.3l-102.9-103  c-11.4-11.4-11.4-29.8,0-41.2c11.4-11.4,29.8-11.4,41.2,0l58,58.1V68.3c0-14.8,12-26.8,26.8-26.8c14.8,0,26.8,12,26.8,26.8v198.9  l57.2-57.2c11.4-11.4,29.8-11.4,41.2,0c11.4,11.4,11.4,29.8,0,41.2L278.6,354.2z"></path>
                                                                                        </svg></span></span>Download</li> }

                                                                                        <li className="delete" onClick={ () => this.enableImageDelete([image.regionname, image.id, image.name]) }><span className="icon"> <span className="svg_wrap"><svg x="0px" y="0px" viewBox="0 0 512 512" enableBackground="new 0 0 512 512" xmlSpace="preserve">
                                                                                            <path fillRule="evenodd" clipRule="evenodd" fill="#4C8CCD" d="M433.5,116.8v303.5c0,27.9-22.7,50.6-50.6,50.6H129.9  c-28,0-50.6-22.7-50.6-50.6V116.8H54.1V66.2h75.9h25.3V40.9h202.4v25.3h25.3h75.9v50.6H433.5z M382.9,116.8H129.9v303.5h252.9V116.8  z M231.1,369.7h-50.6V167.4h50.6V369.7z M332.3,369.7h-50.6V167.4h50.6V369.7z"></path>
                                                                                        </svg></span></span>Delete</li>
                                                                                    </ul>
                                                                                </span>
                                                                                </div> }
                                                                            </div>
                                                                            <div className="progress_container" style={ { display: "none" } }>
                                                                                <p>Copying to Las Vegas, NV, (LV1)</p>
                                                                            </div>

                                                                        </li>
                                                                    ) }
                                                                </ul>
                                                            }
                                                        </div>
                                                        <div className="pagination_inner__box remove-bg" style={ { display: this.state.imagesBackups.length > this.state.count ? '' : 'none' } }>
                                                            <div className="Page_navigation">
                                                                <ul className="pagination_ul">
                                                                    <li className={ this.state.backupIndexCount === 0 ? "page-item disabled" : "page-item" }>
                                                                        <a className="page-link hover-btn" aria-label="Previous" data-tip data-for="prev-page1" onClick={ (event) => { this.handleBackupPreviousClick(event); } }>
                                                                            <ReactToolTip id="prev-page1" place="top" effect="solid">Previous</ReactToolTip>
                                                                            <span aria-hidden="true">«</span>
                                                                            <span className="sr-only">Previous</span>
                                                                        </a>
                                                                    </li>
                                                                    <li className="page-item">
                                                                        <a className="page-link" data-toggle="tooltip" data-placement="top" title="" data-original-title="0-50">
                                                                            { this.state.backupIndexCount + 1 } - { (this.state.backupIndexCount + this.state.count) > this.state.imagesBackups.length ? this.state.imagesBackups.length : (this.state.backupIndexCount + this.state.count) }
                                                                        </a>
                                                                    </li>
                                                                    <li className={ this.state.backupIndexCount + this.state.count > this.state.imagesBackups.length - 1 ? "page-item disabled" : "page-item" }>
                                                                        <a className="page-link hover-btn" aria-label="Next" data-tip data-for="next-page" onClick={ (event) => { this.handleBackupNextClick(event); } }>
                                                                            <ReactToolTip id="next-page" place="top" effect="solid">Next</ReactToolTip>
                                                                            <span aria-hidden="true">»</span>
                                                                            <span className="sr-only">Next</span>
                                                                        </a>
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </div>


                                                    </div>
                                                </div>


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section> :
                            this.state.imagetype === "snapshot" ?
                                <section className="main_section pagination__wrap">
                                    <div className="main_body_container">
                                        <div className="mainBody_colWrap">
                                            <div className="images_container">
                                                <div className="imageMain_table">
                                                    <div className="image_tab_wrap">
                                                        <div className="custom_tabs_wrap">
                                                            <ul>
                                                                <li className={ this.state.imagetype === "backups" ? "active" : "" } onClick={ () => this.imageType(["backups"]) }>Backups</li>
                                                                <li className={ this.state.imagetype === "snapshot" ? "active" : "" } onClick={ () => this.imageType(["snapshot"]) }>Snapshots</li>
                                                                <li className={ this.state.imagetype === "custom" ? "active" : "" } onClick={ () => this.imageType(["custom"]) }>Custom Images</li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                    <div className={ this.state.imagetype === "snapshot" ?
                                                        "imgTabContent imageSnapsotTab_content active" : "imgTabContent imageSnapsotTab_content" }>
                                                        <div className="Image_head_info">
                                                            <p>Manage image backups, snapshots, and custom images of your compute instances. Edit, delete, download, or use the images to create new instances</p>
                                                        </div>
                                                        <div className="tabular_data_wrap sixColumns">
                                                            <div className="table_header">
                                                                <ul>
                                                                    <li className="th">
                                                                        <div className="col col1">
                                                                            <div className="header_sort_wrap" onClick={ (event) => { this.headerSortClick(event); this.setSortable(["snapshot", "name"]); } }>Name<span className="sort_icon "></span></div>
                                                                        </div>
                                                                        <div className="col col2">
                                                                            <div className="header_sort_wrap" onClick={ (event) => { this.headerSortClick(event); this.setSortable(["snapshot", "size"]); } }>Size<span className="sort_icon"></span></div>
                                                                        </div>
                                                                        <div className="col colStatus">
                                                                            <div className="header_sort_wrap" onClick={ (event) => { this.headerSortClick(event); this.setSortable(["snapshot", "status"]); } }>Status<span className="sort_icon"></span></div>
                                                                        </div>
                                                                        <div className="col col3">
                                                                            <div className="header_sort_wrap" onClick={ (event) => { this.headerSortClick(event); this.setSortable(["snapshot", "region"]); } }>Region<span className="sort_icon"></span></div>
                                                                        </div>
                                                                        <div className="col col4">
                                                                            <div className="header_sort_wrap" onClick={ (event) => { this.headerSortClick(event); this.setSortable(["snapshot", "date"]); } }>Created On<span className="sort_icon active"></span></div>
                                                                        </div>
                                                                        <div className="col col5"> Actions</div>
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                            <div className="table_data">
                                                                { this.state.imageSnapshots.length <= 0 ?
                                                                    <ul>
                                                                        <li>
                                                                            <div className="outer_empty_wrap fullPageEmpty">
                                                                                <div className="inner_empty_wrap">
                                                                                    <div className="svg_wrap empty_icon snapshot_empty"></div>
                                                                                    <p className="empty_head">Snapshots</p>
                                                                                    <p className="empty_title">Save a point-in-time copy of a compute instance for restoring it to a previous state or for new instance creation.</p>
                                                                                    <div className="btn_wrap_icon"> </div>

                                                                                </div>
                                                                            </div>
                                                                        </li>
                                                                    </ul>
                                                                    :
                                                                    <ul>
                                                                        { this.state.imageSnapshotsPaged.map((imagesnap, index) =>
                                                                            <li className={ String(imagesnap.name).endsWith("-shelved") ? "tr disabled" : imagesnap.size !== null ? "tr" : "tr progress_tr" } style={ { pointerEvents: String(imagesnap.name).endsWith("-shelved") && localStorage.getItem("status") === 'S' ? 'none' : '' } } key={ index }>
                                                                                <div className='table_col_wrap'>
                                                                                    <div className="col col1">
                                                                                        <div className="name_icon"><span className="svg_wrap snapshot">
                                                                                            <svg x="0px" y="0px" style={ { enableBackground: 'new 0 0 192 192' } }
                                                                                                viewBox="0 0 192 192" xmlSpace="preserve">
                                                                                                <style type="text/css">{ snapCss }</style>
                                                                                                <path className="sts" d="M150.7,150.7H41.3c-8.6,0-15.6-7-15.6-15.6V72.6c0-8.6,7-15.6,15.6-15.6h13l2.6-7.8c0-4.3,3.5-7.8,7.8-7.8h62.5
	                                                                    c4.3,0,7.8,3.5,7.8,7.8l2.6,7.8h13c8.6,0,15.6,7,15.6,15.6v62.5C166.3,143.7,159.3,150.7,150.7,150.7z M115.5,49.1H76.5
	                                                                    c-2.2,0-3.9,1.8-3.9,3.9s1.8,3.9,3.9,3.9h39.1c2.2,0,3.9-1.8,3.9-3.9S117.7,49.1,115.5,49.1z M96,72.6c-17.3,0-31.3,14-31.3,31.3
	                                                                    s14,31.3,31.3,31.3s31.3-14,31.3-31.3S113.3,72.6,96,72.6z M96,119.4c-8.6,0-15.6-7-15.6-15.6s7-15.6,15.6-15.6s15.6,7,15.6,15.6
	                                                                    S104.6,119.4,96,119.4z"/>
                                                                                            </svg>
                                                                                        </span></div>
                                                                                        <div className="row_wrap"> <span className="row row_head" onMouseOver={ (e) => this.showToolTip(e, imagesnap.name) } data-tip data-for={ imagesnap.name }>{ imagesnap.name }</span>
                                                                                            { this.state.getTooltip ?
                                                                                                <ReactToolTip id={ imagesnap.name } effect="solid">{ imagesnap.name }</ReactToolTip> : ""
                                                                                            }
                                                                                            <span className="row row_info">{ imagesnap.name_info }</span> </div>
                                                                                    </div>
                                                                                    { imagesnap.size !== null ?
                                                                                        <div className="col col2">{ formatBytesFloat(imagesnap.size) }</div>
                                                                                        : <div className="col col2">Processing...</div> }
                                                                                    <div className="col colStatus"> { imagesnap.status } </div>
                                                                                    <div className="col col3" >{ imagesnap.fullRegion }</div>
                                                                                    <div className="col col4">{ imagesnap.created }</div>
                                                                                    { imagesnap.size !== null && <div className="col col5"><span className="menu_icon" onClick={ (e) => this.enableImageOptions(
                                                                                        e, imagesnap.id
                                                                                    ) }>
                                                                                        <span className="svg_wrap"><svg className="horizMenuIcon" data-tip data-for="actions" x="0px" y="0px" viewBox="0 0 22.1 6.3" enableBackground="new 0 0 22.1 6.3" xmlSpace="preserve">
                                                                                            <path fillRule="evenodd" clipRule="evenodd" fill="#8692B0" d="M19,5.7c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5  S20.4,5.7,19,5.7z M11,5.7c-1.4,0-2.5-1.1-2.5-2.5S9.6,0.7,11,0.7s2.5,1.1,2.5,2.5S12.4,5.7,11,5.7z M3,5.7c-1.4,0-2.5-1.1-2.5-2.5  S1.6,0.7,3,0.7s2.5,1.1,2.5,2.5S4.4,5.7,3,5.7z"></path>
                                                                                        </svg><ReactToolTip id="actions" place="top" effect="solid">Actions</ReactToolTip></span>
                                                                                        <ul className="dropdown_component image_row_options">
                                                                                            <span className="arrow_pointer"></span>

                                                                                            { imagesnap.size !== null && <li className="instance_create" style={ { display: getReturn(this.state.regionMaintList, imagesnap.regionname) || (this.state.regionList && !this.state.regionList.find(elem => elem.id === imagesnap.regionname)) ? "none" : "" } } onClick={ () => this.createInstanceImage(imagesnap) } ><span className="icon"> <span className="svg_wrap"><svg x="0px" y="0px" viewBox="0 0 512 512" enableBackground="new 0 0 512 512" xmlSpace="preserve">
                                                                                                <path fillRule="evenodd" clipRule="evenodd" fill="#4C8CCD" d="M448.8,287.9H288.5v160.3c0,17.7-14.4,32.1-32.1,32.1l0,0  c-17.7,0-32.1-14.4-32.1-32.1V287.9H64.1c-17.7,0-32.1-14.4-32.1-32.1s14.4-32.1,32.1-32.1h160.3V63.5c0-17.7,14.4-32.1,32.1-32.1  l0,0c17.7,0,32.1,14.4,32.1,32.1v160.3h160.3c17.7,0,32.1,14.4,32.1,32.1S466.5,287.9,448.8,287.9z"></path>
                                                                                            </svg></span></span>Create an instance</li> }
                                                                                            { imagesnap.size !== null && <li className="regionSlider" onClick={ () => this.copyToRegion(
                                                                                                imagesnap.id, imagesnap.regionname, imagesnap.name
                                                                                            ) }>
                                                                                                <span className="icon">
                                                                                                    <span className="svg_wrap">
                                                                                                        <svg x="0px" y="0px" viewBox="0 0 22.7 22.7" enableBackground="new 0 0 22.7 22.7" xmlSpace="preserve">
                                                                                                            <g>
                                                                                                                <path className="rn0" d="M17.9,8.2c0,1.5-0.5,2.8-1.3,3.9l-5,8.9c-0.1,0.2-0.4,0.2-0.5,0l-5-8.9c-0.8-1.1-1.3-2.4-1.3-3.9
                                                                                                                c0-3.9,3.4-7,7.4-6.5C15.5,2,17.9,4.8,17.9,8.2z"></path>
                                                                                                                <circle className="rn0" cx="11.3" cy="8" r="2.6"></circle>
                                                                                                            </g>
                                                                                                        </svg>
                                                                                                    </span>
                                                                                                </span>Add to Region
                                                                                            </li> }
                                                                                            { imagesnap.size !== null && <li className="edit" onClick={ () => this.enableBackupEdit([
                                                                                                imagesnap.id, imagesnap.regionname, imagesnap.name
                                                                                            ]) }><span className="icon"> <span className="svg_wrap"><svg x="0px" y="0px" width="19.6px" height="16.5px" viewBox="0 0 19.6 16.5" enableBackground="new 0 0 19.6 16.5" xmlSpace="preserve">
                                                                                                <path fillRule="evenodd" clipRule="evenodd" fill="#909AAA" d="M16.2,5.5l-0.7,0.7l-0.7,0.7l-6.2,6.8h5.2c0.6,0,1,0.4,1,1  s-0.4,1-1,1h-10l0,0h-1v-4l7.8-9L11.3,2L12,1.3c0.8-0.8,2-0.8,2.8,0l1.4,1.4C17,3.5,17,4.8,16.2,5.5z M11.7,4.5L5.1,12  c-0.4,0.4-0.4,1,0,1.4c0.4,0.4,1,0.4,1.4,0l6.6-7.6L11.7,4.5z"></path>
                                                                                            </svg></span></span>Edit</li> }
                                                                                            { imagesnap.size !== null && <li className="download" onClick={ (e) => this.downloadImage(e, imagesnap.id, imagesnap.name, imagesnap.regionname) }><span className="icon"> <span className="svg_wrap"><svg x="0px" y="0px" viewBox="0 0 512 512" enableBackground="new 0 0 512 512" xmlSpace="preserve">
                                                                                                <path fillRule="evenodd" clipRule="evenodd" fill="#4C8CCD" d="M417.2,470.3H95.6c-29.6,0-53.6-24-53.6-53.6v-80.4h53.6v80.4  h321.6v-80.4h53.6v80.4C470.8,446.3,446.8,470.3,417.2,470.3z M278.6,354.2c-3.4,3.4-7.5,5.4-11.8,6.8c-3.2,1.4-6.8,2.1-10.5,2.1  c-0.9,0-1.6-0.3-2.5-0.4c0,0-0.1,0-0.1,0c-2.2-0.2-4.4-0.5-6.4-1.3c-5.1-1.2-10.1-3.2-14.1-7.3l-102.9-103  c-11.4-11.4-11.4-29.8,0-41.2c11.4-11.4,29.8-11.4,41.2,0l58,58.1V68.3c0-14.8,12-26.8,26.8-26.8c14.8,0,26.8,12,26.8,26.8v198.9  l57.2-57.2c11.4-11.4,29.8-11.4,41.2,0c11.4,11.4,11.4,29.8,0,41.2L278.6,354.2z"></path>
                                                                                            </svg></span></span>Download</li> }
                                                                                            { imagesnap.size !== null && <li className="delete" onClick={ () => this.enableImageDelete([imagesnap.regionname, imagesnap.id, imagesnap.name]) }><span className="icon"> <span className="svg_wrap"><svg x="0px" y="0px" viewBox="0 0 512 512" enableBackground="new 0 0 512 512" xmlSpace="preserve">
                                                                                                <path fillRule="evenodd" clipRule="evenodd" fill="#4C8CCD" d="M433.5,116.8v303.5c0,27.9-22.7,50.6-50.6,50.6H129.9  c-28,0-50.6-22.7-50.6-50.6V116.8H54.1V66.2h75.9h25.3V40.9h202.4v25.3h25.3h75.9v50.6H433.5z M382.9,116.8H129.9v303.5h252.9V116.8  z M231.1,369.7h-50.6V167.4h50.6V369.7z M332.3,369.7h-50.6V167.4h50.6V369.7z"></path>
                                                                                            </svg></span></span>Delete</li> }
                                                                                        </ul>
                                                                                    </span>
                                                                                    </div> }
                                                                                </div>
                                                                                <div className="progress_container" style={ { display: "none" } }>
                                                                                    <p>Copying to Las Vegas, NV, (LV1)</p>
                                                                                </div>
                                                                            </li>
                                                                        ) }
                                                                    </ul>
                                                                }
                                                            </div>
                                                            <div className="pagination_inner__box remove-bg" style={ { display: this.state.imageSnapshots.length > this.state.count ? '' : 'none' } }>
                                                                <div className="Page_navigation">
                                                                    <ul className="pagination_ul">
                                                                        <li className={ this.state.snapIndexCount === 0 ? "page-item disabled" : "page-item" }>
                                                                            <a className="page-link hover-btn" aria-label="Previous" data-tip data-for="prev-page2" onClick={ (event) => { this.handleSnapPreviousClick(event); } }>
                                                                                <ReactToolTip id="prev-page2" place="top" effect="solid">Previous</ReactToolTip>
                                                                                <span aria-hidden="true">«</span>
                                                                                <span className="sr-only">Previous</span>
                                                                            </a>
                                                                        </li>
                                                                        <li className="page-item">
                                                                            <a className="page-link" data-toggle="tooltip" data-placement="top" title="" data-original-title="0-50">
                                                                                { this.state.snapIndexCount + 1 } - { (this.state.snapIndexCount + this.state.count) > this.state.imageSnapshots.length ? this.state.imageSnapshots.length : (this.state.snapIndexCount + this.state.count) }
                                                                            </a>
                                                                        </li>
                                                                        <li className={ this.state.snapIndexCount + this.state.count > this.state.imageSnapshots.length - 1 ? "page-item disabled" : "page-item" }>
                                                                            <a className="page-link hover-btn" aria-label="Next" data-tip data-for="next-page2" onClick={ (event) => { this.handleSnapNextClick(event); } }>
                                                                                <ReactToolTip id="next-page2" place="top" effect="solid">Next</ReactToolTip>
                                                                                <span aria-hidden="true">»</span>
                                                                                <span className="sr-only">Next</span>
                                                                            </a>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </div>


                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                                : <section className="main_section pagination__wrap">
                                    <div className="main_body_container">
                                        <div className="mainBody_colWrap">
                                            <div className="images_container">
                                                <div className="imageMain_table">
                                                    <div className="image_tab_wrap">
                                                        <div className="custom_tabs_wrap">
                                                            <ul>
                                                                <li className={ this.state.imagetype === "backups" ? "active" : "" } onClick={ () => this.imageType(["backups"]) }>Backups</li>
                                                                <li className={ this.state.imagetype === "snapshot" ? "active" : "" } onClick={ () => this.imageType(["snapshot"]) }>Snapshots</li>
                                                                <li className={ this.state.imagetype === "custom" ? "active" : "" } onClick={ () => this.imageType(["custom"]) }>Custom Images</li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                    <div className={ this.state.imagetype === "custom" ?
                                                        "imgTabContent imageCustImgTab_content active" : "imgTabContent imageCustImgTab_content" }>
                                                        <div className="Image_head_info">

                                                            <p>Manage image backups, snapshots, and custom images of your compute instances. Edit, delete, download, or use the images to create new instances</p>
                                                        </div>
                                                        <div className="tabular_data_wrap">
                                                            <div className="table_header">
                                                                <ul>
                                                                    <li className="th">
                                                                        <div className="col col1">
                                                                            <div className="header_sort_wrap" onClick={ (event) => { this.headerSortClick(event); this.setSortable(["custom", "name"]); } }>Name<span className="sort_icon"></span></div>
                                                                        </div>
                                                                        <div className="col col2">
                                                                            <div className="header_sort_wrap" onClick={ (event) => { this.headerSortClick(event); this.setSortable(["custom", "size"]); } }>Size<span className="sort_icon"></span></div>
                                                                        </div>
                                                                        <div className="col col3">
                                                                            <div className="header_sort_wrap" onClick={ (event) => { this.headerSortClick(event); this.setSortable(["custom", "status"]); } }>Status<span className="sort_icon"></span></div>
                                                                        </div>
                                                                        <div className="col col4">
                                                                            <div className="header_sort_wrap" onClick={ (event) => { this.headerSortClick(event); this.setSortable(["custom", "region"]); } }>Region<span className="sort_icon"></span></div>
                                                                        </div>
                                                                        <div className="col col5">
                                                                            <div className="header_sort_wrap" onClick={ (event) => { this.headerSortClick(event); this.setSortable(["custom", "date"]); } }>Created On<span className="sort_icon active"></span></div>
                                                                        </div>
                                                                        <div className="col col6"> Actions</div>
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                            <div className="table_data">
                                                                { this.state.customImages.length <= 0 ?
                                                                    <ul>
                                                                        <li>
                                                                            <div className="outer_empty_wrap fullPageEmpty">
                                                                                <div className="inner_empty_wrap">
                                                                                    <div className="svg_wrap empty_icon customImg_empty"></div>
                                                                                    <p className="empty_head">Custom Images</p>
                                                                                    <p className="empty_title">Upload an image from hard disk or import via URL to create an instance with custom OS of your choice.</p>
                                                                                    <div className="btn_wrap_icon"></div>

                                                                                </div>
                                                                            </div>
                                                                        </li>
                                                                    </ul>
                                                                    :
                                                                    <ul>
                                                                        { this.state.customImagesPaged.map((custom, index) =>
                                                                            <li className={ this.state.copyImages.find(e => e == custom.id) ? "tr progressEnabled" : "tr " } key={ index }>
                                                                                <div className='table_col_wrap'>
                                                                                    <div className="col col1">
                                                                                        <div className="name_icon"><span className="svg_wrap custom">
                                                                                            <svg y="0px" style={ { enableBackground: 'new 0 0 192 192' } }
                                                                                                viewBox="0 0 192 192" xmlSpace="preserve">
                                                                                                <style type="text/css">{ customCss }</style>
                                                                                                <g className="st0">
                                                                                                    <path className="st1" d="M24.7,51.6c8.1,12.3,31,21.1,58.1,21.1c26.9,0,49.8-8.8,58-20.9V47h0c0-0.1,0-0.2,0-0.3
		                                                                            c0-12.9-26-23.4-58-23.4s-58,10.5-58,23.4c0,0.1,0,0.2,0,0.3h0V51.6z"/>
                                                                                                    <path className="st1" d="M94.3,125.7c-3.7,0.4-7.5,0.5-11.5,0.5c-27.1,0-50-8.9-58.1-21.1V137h0c0.2,12.9,26.1,23.3,58,23.3
		                                                                            c9.6,0,18.6-0.9,26.6-2.6C100.3,149.9,94.5,138.5,94.3,125.7z"/>
                                                                                                    <path className="st1" d="M137.2,82c1.2,0,2.4,0.1,3.6,0.2V61.3c-8.2,12.2-31.1,20.9-58,20.9c-27.1,0-50-8.9-58.1-21.1v34.5
		                                                                            c8.1,12.3,31,21.1,58.1,21.1c4.2,0,8.4-0.2,12.4-0.6C99.3,96.7,116.5,82,137.2,82z"/>
                                                                                                    <path className="st1" d="M137.1,88.5c-20.4,0-37,16.6-37,37c0,20.4,16.6,37,37,37c20.4,0,37-16.6,37-37
		                                                                            C174.1,105.1,157.6,88.5,137.1,88.5z M144.6,125.3v23.4h-14.9v-23.4h-15.5l23-23l23,23H144.6z"/>
                                                                                                </g>
                                                                                                <g>
                                                                                                    <path className="st2" d="M112.7,69.4H59.4V76h53.3V69.4z M66,93.1v-7.7c0-1.5-1.2-2.8-2.8-2.8H42.6c-1.4,0-2.3-1.6-1.6-2.8l15.1-25.1
		                                                                            c2-3.3,5.6-5.4,9.5-5.4h40.7c3.9,0,7.5,2,9.5,5.4l12.9,21.4c1.3-0.1,2.6-0.2,3.9-0.2c2,0,4,0.2,6,0.5l-15.8-27.6
		                                                                            c-2.2-3.8-6.3-6.2-10.7-6.2H59.8c-4.4,0-8.5,2.4-10.7,6.2L28.3,85.4c-1.5,2.6-2.2,5.5-2.2,8.4v35.4c0,3.7,3,6.7,6.7,6.7h65.3
		                                                                            c-3.4-5.9-5.4-12.7-5.4-20c0-7.3,2-14.1,5.4-20H68.9C67.3,96,66,94.7,66,93.1z M132.6,82.7c-18.4,0-33.3,14.9-33.3,33.3
		                                                                            s14.9,33.3,33.3,33.3s33.3-14.9,33.3-33.3S151,82.7,132.6,82.7z M136.9,142.3c-18,2.8-33.3-12.5-30.5-30.5
		                                                                            c1.7-11.2,10.9-20.4,22.1-22.1c18-2.8,33.3,12.5,30.5,30.5C157.2,131.4,148.1,140.6,136.9,142.3z M126,122.6v13.3h13.3v-13.3h13.3
		                                                                            l-20-26.6l-20,26.6H126z M66,56v6.7h40V56H66z"/>
                                                                                                </g>
                                                                                            </svg>
                                                                                        </span></div>
                                                                                        <div className="row_wrap"> <span className="row row_head" onMouseOver={ (e) => this.showToolTip(e, custom.name) } data-tip data-for={ custom.name }>{ custom.name }</span>
                                                                                            { this.state.getTooltip ?
                                                                                                <ReactToolTip id={ custom.name } multiline={ true } effect="solid">{ custom.name }</ReactToolTip> : ""
                                                                                            }
                                                                                            <span className="row row_info">{ custom.name_info }</span> </div>
                                                                                    </div>
                                                                                    { custom.size !== null ?
                                                                                        <div className="col col2">{ formatBytesFloat(custom.size) }</div>
                                                                                        : <div className="col col2">Processing...</div> }
                                                                                    <div className="col col3"> { custom.status } </div>
                                                                                    <div className="col col4"> { custom.fullRegion } </div>
                                                                                    <div className="col col5">{ custom.created }</div>
                                                                                    <div className="col col6"><span className="menu_icon" onClick={ (e) => this.enableImageOptions(
                                                                                        e, custom.id
                                                                                    ) }><span className="svg_wrap"><svg className="horizMenuIcon" data-tip data-for="actions" x="0px" y="0px" viewBox="0 0 22.1 6.3" enableBackground="new 0 0 22.1 6.3" xmlSpace="preserve">
                                                                                        <path fillRule="evenodd" clipRule="evenodd" fill="#8692B0" d="M19,5.7c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5  S20.4,5.7,19,5.7z M11,5.7c-1.4,0-2.5-1.1-2.5-2.5S9.6,0.7,11,0.7s2.5,1.1,2.5,2.5S12.4,5.7,11,5.7z M3,5.7c-1.4,0-2.5-1.1-2.5-2.5  S1.6,0.7,3,0.7s2.5,1.1,2.5,2.5S4.4,5.7,3,5.7z"></path>
                                                                                    </svg><ReactToolTip id="actions" place="top" effect="solid">Actions</ReactToolTip></span>
                                                                                        <ul className="dropdown_component image_row_options">
                                                                                            <span className="arrow_pointer"></span>
                                                                                            { custom.size !== null && <li className="instance_create" style={ { display: getReturn(this.state.regionMaintList, custom.regionname) || (this.state.regionList && !this.state.regionList.find(elem => elem.id === custom.regionname)) ? "none" : "" } } onClick={ () => this.createInstanceImage(custom) }><span className="icon"> <span className="svg_wrap"><svg x="0px" y="0px" viewBox="0 0 512 512" enableBackground="new 0 0 512 512" xmlSpace="preserve">
                                                                                                <path fillRule="evenodd" clipRule="evenodd" fill="#4C8CCD" d="M448.8,287.9H288.5v160.3c0,17.7-14.4,32.1-32.1,32.1l0,0  c-17.7,0-32.1-14.4-32.1-32.1V287.9H64.1c-17.7,0-32.1-14.4-32.1-32.1s14.4-32.1,32.1-32.1h160.3V63.5c0-17.7,14.4-32.1,32.1-32.1  l0,0c17.7,0,32.1,14.4,32.1,32.1v160.3h160.3c17.7,0,32.1,14.4,32.1,32.1S466.5,287.9,448.8,287.9z"></path>
                                                                                            </svg></span></span>Create an instance</li> }
                                                                                            { custom.size !== null && <li className="regionSlider" onClick={ () => this.copyToRegion(
                                                                                                custom.id, custom.regionname, custom.name
                                                                                            ) }>
                                                                                                <span className="icon">
                                                                                                    <span className="svg_wrap">
                                                                                                        <svg x="0px" y="0px" viewBox="0 0 22.7 22.7" enableBackground="new 0 0 22.7 22.7" xmlSpace="preserve">
                                                                                                            <g>
                                                                                                                <path className="rn0" d="M17.9,8.2c0,1.5-0.5,2.8-1.3,3.9l-5,8.9c-0.1,0.2-0.4,0.2-0.5,0l-5-8.9c-0.8-1.1-1.3-2.4-1.3-3.9
                                                                                                                        c0-3.9,3.4-7,7.4-6.5C15.5,2,17.9,4.8,17.9,8.2z"></path>
                                                                                                                <circle className="rn0" cx="11.3" cy="8" r="2.6"></circle>
                                                                                                            </g>
                                                                                                        </svg>
                                                                                                    </span>
                                                                                                </span>Add to Region
                                                                                            </li> }
                                                                                            { custom.size !== null && <li className="edit" onClick={ () => this.enableBackupEdit([
                                                                                                custom.id, custom.regionname, custom.name
                                                                                            ]) }><span className="icon"> <span className="svg_wrap"><svg x="0px" y="0px" width="19.6px" height="16.5px" viewBox="0 0 19.6 16.5" enableBackground="new 0 0 19.6 16.5" xmlSpace="preserve">
                                                                                                <path fillRule="evenodd" clipRule="evenodd" fill="#909AAA" d="M16.2,5.5l-0.7,0.7l-0.7,0.7l-6.2,6.8h5.2c0.6,0,1,0.4,1,1  s-0.4,1-1,1h-10l0,0h-1v-4l7.8-9L11.3,2L12,1.3c0.8-0.8,2-0.8,2.8,0l1.4,1.4C17,3.5,17,4.8,16.2,5.5z M11.7,4.5L5.1,12  c-0.4,0.4-0.4,1,0,1.4c0.4,0.4,1,0.4,1.4,0l6.6-7.6L11.7,4.5z"></path>
                                                                                            </svg></span></span>Edit</li> }
                                                                                            { custom.status === "active" ?
                                                                                                <li className="download" onClick={ (e) => this.downloadImage(e, custom.id, custom.name, custom.regionname) }><span className="icon"> <span className="svg_wrap"><svg x="0px" y="0px" viewBox="0 0 512 512" enableBackground="new 0 0 512 512" xmlSpace="preserve">
                                                                                                    <path fillRule="evenodd" clipRule="evenodd" fill="#4C8CCD" d="M417.2,470.3H95.6c-29.6,0-53.6-24-53.6-53.6v-80.4h53.6v80.4  h321.6v-80.4h53.6v80.4C470.8,446.3,446.8,470.3,417.2,470.3z M278.6,354.2c-3.4,3.4-7.5,5.4-11.8,6.8c-3.2,1.4-6.8,2.1-10.5,2.1  c-0.9,0-1.6-0.3-2.5-0.4c0,0-0.1,0-0.1,0c-2.2-0.2-4.4-0.5-6.4-1.3c-5.1-1.2-10.1-3.2-14.1-7.3l-102.9-103  c-11.4-11.4-11.4-29.8,0-41.2c11.4-11.4,29.8-11.4,41.2,0l58,58.1V68.3c0-14.8,12-26.8,26.8-26.8c14.8,0,26.8,12,26.8,26.8v198.9  l57.2-57.2c11.4-11.4,29.8-11.4,41.2,0c11.4,11.4,11.4,29.8,0,41.2L278.6,354.2z"></path>
                                                                                                </svg></span></span>Download</li> : "" }
                                                                                            <li className="delete" onClick={ () => this.enableImageDelete([custom.regionname, custom.id, custom.name]) }><span className="icon"> <span className="svg_wrap"><svg x="0px" y="0px" viewBox="0 0 512 512" enableBackground="new 0 0 512 512" xmlSpace="preserve">
                                                                                                <path fillRule="evenodd" clipRule="evenodd" fill="#4C8CCD" d="M433.5,116.8v303.5c0,27.9-22.7,50.6-50.6,50.6H129.9  c-28,0-50.6-22.7-50.6-50.6V116.8H54.1V66.2h75.9h25.3V40.9h202.4v25.3h25.3h75.9v50.6H433.5z M382.9,116.8H129.9v303.5h252.9V116.8  z M231.1,369.7h-50.6V167.4h50.6V369.7z M332.3,369.7h-50.6V167.4h50.6V369.7z"></path>
                                                                                            </svg></span></span>Delete</li>
                                                                                        </ul>
                                                                                    </span>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="progress_container" style={ { display: this.state.copyImages.find(e => e == custom.id) ? "" : "none" } }>
                                                                                    <p>Copying to { custom.fullRegion } region</p>
                                                                                </div>
                                                                            </li>
                                                                        ) }
                                                                    </ul>
                                                                }
                                                            </div>

                                                            <div className="pagination_inner__box remove-bg" style={ { display: this.state.customImages.length > this.state.count ? '' : 'none' } }>
                                                                <div className="Page_navigation">
                                                                    <ul className="pagination_ul">
                                                                        <li className={ this.state.customIndexCount === 0 ? "page-item disabled" : "page-item" }>
                                                                            <a className="page-link hover-btn" aria-label="Previous" data-tip data-for="prev-page3" onClick={ (event) => { this.handleCustomPreviousClick(event); } }>
                                                                                <ReactToolTip id="prev-page3" place="top" effect="solid">Previous</ReactToolTip>
                                                                                <span aria-hidden="true">«</span>
                                                                                <span className="sr-only">Previous</span>
                                                                            </a>
                                                                        </li>
                                                                        <li className="page-item">
                                                                            <a className="page-link" data-toggle="tooltip" data-placement="top" title="" data-original-title="0-50">
                                                                                { this.state.customIndexCount + 1 } - { (this.state.customIndexCount + this.state.count) > this.state.customImages.length ? this.state.customImages.length : (this.state.customIndexCount + this.state.count) }
                                                                            </a>
                                                                        </li>
                                                                        <li className={ this.state.customIndexCount + this.state.count > this.state.customImages.length - 1 ? "page-item disabled" : "page-item" }>
                                                                            <a className="page-link hover-btn" aria-label="Next" data-tip data-for="next-page3" onClick={ (event) => { this.handleCustomNextClick(event); } }>
                                                                                <ReactToolTip id="next-page3" place="top" effect="solid">Next</ReactToolTip>
                                                                                <span aria-hidden="true">»</span>
                                                                                <span className="sr-only">Next</span>
                                                                            </a>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </div>


                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section> }
                        <div className={ this.state.imagetype === "backups" ? "main_slider ImageModule_editBackup" :
                            this.state.imagetype === "snapshot" ? "main_slider ImageModule_editSnapshot" :
                                "main_slider ImageModule_editCustom" } onKeyPress={ (e) => this.enterPressed(e, "edit") }>
                            <div className="slider_bg_shadow"></div>
                            <div className="slider_wrapper">
                                <div className="main_slider_container">
                                    <div className="close_icon" data-tip data-for="close" onClick={ (e) => { this.closeEditImage(e); } }></div>
                                    <ReactToolTip id="close" effect="solid">
                                        Close
                                    </ReactToolTip>
                                    <div className="imgModuleRhs_slide_wrap">
                                        <div className="head_block">
                                            <h2><span className="icon_img"> <span className="svg_wrap"><svg x="0px" y="0px" width="19.6px" height="16.5px" viewBox="0 0 19.6 16.5" enableBackground="new 0 0 19.6 16.5" xmlSpace="preserve">
                                                <path fillRule="evenodd" clipRule="evenodd" fill="#909AAA" d="M16.2,5.5l-0.7,0.7l-0.7,0.7l-6.2,6.8h5.2c0.6,0,1,0.4,1,1  s-0.4,1-1,1h-10l0,0h-1v-4l7.8-9L11.3,2L12,1.3c0.8-0.8,2-0.8,2.8,0l1.4,1.4C17,3.5,17,4.8,16.2,5.5z M11.7,4.5L5.1,12  c-0.4,0.4-0.4,1,0,1.4c0.4,0.4,1,0.4,1.4,0l6.6-7.6L11.7,4.5z"></path>
                                            </svg></span> </span>{ this.state.imagetype === "backups" ? "Edit Backup" : this.state.imagetype === "snapshot" ? "Edit Snapshot" : "Edit Image" }</h2>
                                        </div>
                                        <div className="imgModuleRhs_content_wrap">
                                            { this.state.imagetype === "backups" ? <p className="info_txt" style={ { display: "none" } }>Modify backup name</p> :
                                                this.state.imagetype === "snapshot" ? <p className="info_txt" style={ { display: "none" } }>Edit Snapshot</p> : <p className="info_txt" style={ { display: "none" } }>Modify image name</p> }

                                            <div className="common_txtBox_row">
                                                <label>Name</label>
                                                <input type="text" maxLength="20" ref={ this.editnamefocus } placeholder="Provide a new name" id="editImageName" name="editImageName" value={ this.state.editImageName } className="txt_box" onChange={ this.handleInput }></input>
                                                <span className="err_msg" style={ { display: this.state.editnameempty ? 'inline-block' : 'none', color: "red" } } >Name cannot be blank</span>
                                                <span className="err_msg" style={ { display: this.state.nameErrMessg ? 'inline-block' : 'none', color: "red" } } >{ this.state.nameErrMessg }</span>
                                            </div>
                                            <div className="common_txtBox_row">
                                                <label>Region</label>
                                                <input type="text" name="editImageRegion" value={ this.state.editImageRegion } className="txt_box disabled" placeholder="New York" readOnly></input>
                                            </div>
                                            <div className="cta_wrap">
                                                <input type="button" name="" value="Save Changes" className={ this.state.iseditButtonClick ? "common_cta_btn blue disabled" : "common_cta_btn blue" } onClick={ (e) => this.editImage(e) } disabled={ this.state.iseditButtonClick }></input>
                                                <input type="button" name="" value="Cancel" className="common_cta_btn transparentGrey" onClick={ (e) => { this.closeEditImage(e); } }></input>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        { this.state.imagetype === "custom" ?
                            <div className="main_slider ImageModule_CustomImgUpload">
                                <div className="slider_bg_shadow"></div>
                                <div className="slider_wrapper">
                                    <div className="main_slider_container">
                                        <div className="close_icon" data-tip data-for="close" onClick={ (e) => { this.closeUploadImage(e); } }>
                                        </div><ReactToolTip id="close" effect="solid">
                                            Close
                                        </ReactToolTip>
                                        <div className="imgModuleRhs_slide_wrap">
                                            <div className="head_block">
                                                <h2><span className="icon_img"> <span className="svg_wrap"><svg x="0px" y="0px" width="19.6px" height="16.5px" viewBox="0 0 19.6 16.5" enableBackground="new 0 0 19.6 16.5" xmlSpace="preserve">
                                                    <path fillRule="evenodd" clipRule="evenodd" fill="#909AAA" d="M16.2,5.5l-0.7,0.7l-0.7,0.7l-6.2,6.8h5.2c0.6,0,1,0.4,1,1  s-0.4,1-1,1h-10l0,0h-1v-4l7.8-9L11.3,2L12,1.3c0.8-0.8,2-0.8,2.8,0l1.4,1.4C17,3.5,17,4.8,16.2,5.5z M11.7,4.5L5.1,12  c-0.4,0.4-0.4,1,0,1.4c0.4,0.4,1,0.4,1.4,0l6.6-7.6L11.7,4.5z"></path>
                                                </svg></span> </span>Upload or import a custom image.</h2>
                                            </div>
                                            <div className="imgModuleRhs_content_wrap">
                                                <p className="info_txt">Custom images are billed per month at <b>$0.05/GB</b>. The custom image size cannot be more than <b>2 TB</b>.</p>
                                                <p className="info_txt" style={ { display: "none" } }>Create an instance with an image of an existing OS</p>
                                                <div className="imgUploadOptn_radio_wrap">
                                                    <label className={ this.state.radioButtonPlan === "upload" ? "custom_radio uploadImgRadio active" : "custom_radio uploadImgRadio" }>Upload from hard disk
                                                        <input type="radio" checked={ this.state.radioButtonPlan === "upload" } name="imgUpload_options" onChange={ () => this.getRadioButtonStatus("upload") }></input>
                                                        <span className="checkmark"></span> </label>
                                                    <label className={ this.state.radioButtonPlan === "import" ? "custom_radio importUrlRadio active" : "custom_radio importUrlRadio" }>Import via URL
                                                        <input type="radio" checked={ this.state.radioButtonPlan === "import" } name="imgUpload_options" onChange={ () => this.getRadioButtonStatus("import") }></input>
                                                        <span className="checkmark"></span> </label>
                                                </div>
                                                <div className="common_txtBox_row">
                                                    <label>Regions</label>
                                                    <div className={ this.state.regionContainerFocus ? "region_select_container active" : "region_select_container" }>
                                                        <div className="slectBox" onClick={ () => { this.getRegionDropdown(); } }>
                                                            <div className={ this.state.isregionselected ? "search_inp_box optSelect" : "search_inp_box optUnselect" }>
                                                                <input type="text" autoComplete="off" ref={ this.uploadRegionFocus } name="uploadRegion" value={ this.state.uploadRegion } placeholder="Select a Region" onChange={ this.filterDropDown }></input>
                                                                <input type="hidden" name="regionid" value={ this.state.regionid }></input>
                                                            </div>
                                                            <ul>
                                                                <li className="selected_elem"><span className={ this.state.uploadRegion.length > 0 ? "country_flag " + this.state.countryName.toLowerCase() : "" }></span>{ this.state.uploadRegion.length <= 0 ? this.state.uploadRegion : this.state.uploadRegion + " (" + this.state.regionid + ")" }</li>
                                                            </ul>
                                                            <span className="dropArrow"> <svg className="header_nav_dropdown" viewBox="0 0 10 5">
                                                                <title>drop-down</title>
                                                                <polygon className="cls-1" points="5 5 0 0 10 0 5 5"></polygon>
                                                            </svg>
                                                            </span>
                                                        </div>
                                                        <div className="regionSelect_options">

                                                            { this.state.regionListFilter.length <= 0 ?
                                                                <ul className="noSearchRes">
                                                                    <li>No Regions Found</li>
                                                                </ul>
                                                                :
                                                                <ul>
                                                                    <ScrollArea
                                                                        speed={ 0.8 }
                                                                        style={ { maxHeight: "245px" } }
                                                                        vertical={ true }
                                                                        horizontal={ false }
                                                                        minScrollSize={ 10 }
                                                                        smoothScrolling={ false }
                                                                        verticalScrollbarStyle={ { backgroundColor: "#C1C1C1", opacity: "1" } }
                                                                        verticalContainerStyle={ { backgroundColor: "#F1F1F1", opacity: "1" } }
                                                                        stopScrollPropagation={ true }
                                                                    >
                                                                        { this.state.regionListFilter.map((region, i) =>
                                                                            <li className={ "option_elem " + region.statusClass } key={ i } onMouseDown={ (e) => this.getSelectedRegion(e, region) } disabled={ region.status !== 1 }><span className={ 'country_flag ' + region.countryName.toLowerCase() } ></span>{ region.name } ({ region.id })<span className="algin_right__arrow" style={ { display: region.status === 1 ? 'none' : '' } }>{ region.statusName }</span>
                                                                            </li>
                                                                        ) }

                                                                    </ScrollArea>
                                                                </ul>
                                                            }
                                                        </div>
                                                    </div>

                                                    <span className="err_msg" style={ { display: this.state.regionempty ? 'inline-block' : 'none', color: "red" } } >Region cannot be blank</span>
                                                </div>
                                                <div className="common_txtBox_row imgUrlBox" style={ { display: this.state.showImageUrlBox ? "block" : "none" } }>
                                                    <label>Enter URL</label>
                                                    <input type="text" name="importImageUrl" ref={ this.importurlfocus } value={ this.state.importImageUrl } onFocus={ () => this.getFocus("importurl") } onClick={ () => this.getFocus("importurl") } className="txt_box" onChange={ this.handleInput } autoComplete="chrome-off"></input>
                                                    <span className="err_msg" style={ { display: this.state.importurlempty ? 'inline-block' : 'none', color: "red" } } >URL cannot be blank</span>
                                                </div>
                                                <div className="common_txtBox_row imgUrlBox" style={ { display: this.state.showImageUrlBox ? "block" : "none" } }>

                                                    <label>Name</label>
                                                    <input type="text" maxLength="20" placeholder="Provide a name" name="importImageName" onFocus={ () => this.getFocus("importname") } onClick={ () => this.getFocus("importname") } ref={ this.importnamefocus } value={ this.state.importImageName } className="txt_box" onChange={ this.handleInput } autoComplete="chrome-off"></input>
                                                    <span className="err_msg" style={ { display: this.state.importnameempty ? 'inline-block' : 'none', color: "red" } } >Image name cannot be blank</span>
                                                    <span className="err_msg" style={ { display: this.state.nameErrMessg ? 'inline-block' : 'none', color: "red" } } >{ this.state.nameErrMessg }</span>
                                                </div>
                                                <div className="common_txtBox_row imgUploadBox" style={ { display: this.state.showImageUploadBox ? "block" : "none" } }>
                                                    <label>Name</label>
                                                    <input type="text" maxLength="20" placeholder="Provide a name" onFocus={ () => this.getFocus("name") } onClick={ () => this.getFocus("name") } ref={ this.uploadnamefocus } id="imagenamefocus" name="uploadImageName" value={ this.state.uploadImageName } className="txt_box" onChange={ this.handleInput } autoComplete="chrome-off"></input>
                                                    <span className="err_msg" style={ { display: this.state.uploadnameempty ? 'inline-block' : 'none', color: "red" } } >Image name cannot be blank</span>
                                                    <span className="err_msg" style={ { display: this.state.nameErrMessg ? 'inline-block' : 'none', color: "red" } } >{ this.state.nameErrMessg }</span>
                                                </div>
                                                <div className="common_txtBox_row fileUploadBox" style={ { display: this.state.showImageUploadBox ? "block" : "none" } }>
                                                    <label className="chooseImgLabel">Choose Image File</label>
                                                    <div className="custom_fileUpload_btn">
                                                        <label htmlFor="file-upload" className="custom-file-upload">Choose File</label>
                                                        <input id="file-upload" type="file" onClick={ (event) => { this.handleFileOperation(event); } } onChange={ this.handleFile } onFocus={ getFocusForFile() } onBlur={ getBlurForFile() }></input>
                                                        <span className="file_name" data-tip data-for="filename">{ this.state.fileName.length <= 38 ? this.state.fileName : this.state.fileName.slice(0, 38) + "..." }</span>
                                                        <ReactToolTip id="filename" effect="solid" place="top">{ this.state.fileName }</ReactToolTip>
                                                    </div>
                                                    <span className="img_size">Image size : { this.state.fileSize }</span>
                                                    <span className="err_msg" style={ { display: this.state.uploadfileempty ? 'inline-block' : 'none', color: "red" } } >File cannot be blank</span>
                                                    <span className="err_msg" style={ { display: this.state.uploadfileerror ? 'inline-block' : 'none', color: "red" } } >Invalid file format</span>
                                                </div>


                                                <div className="common_txtBox_row" style={ { display: "none" } }>
                                                    <label>Container Format<span className="question_icon" data-tip data-for="container"><svg x="0px" y="0px" viewBox="0 0 22 20" enableBackground="new 0 0 22 20" xmlSpace="preserve">
                                                        <path fillRule="evenodd" clipRule="evenodd" fill="#89A2BE" d="M11,1c5,0,9,4,9,9s-4,9-9,9c-5,0-9-4-9-9S6,1,11,1z"></path>
                                                        <text transform="matrix(1 0 0 1 7.0724 15.4681)" fill="#FFFFFF" fontFamily="'Roboto-Medium'" fontSize="16px">?</text>
                                                    </svg></span><ReactToolTip id="container" multiline={ true } effect="solid" place="top">
                                                            The container type of the<br></br> virtual disk such as bare, aki, ari,<br></br> docker, compressed, etc.
                                                        </ReactToolTip> </label>
                                                    <div className="custom_select_box">
                                                        <select value={ this.state.uploadContainerFormat } onFocus={ () => this.getFocus("container") } onClick={ () => this.getFocus("container") } name="uploadContainerFormat" onChange={ this.handleInput } required>
                                                            <option value="" style={ { display: "none" } } disabled>Select the container format</option>
                                                            <option value="ami">ami</option>
                                                            <option value="ari">ari</option>
                                                            <option value="aki">aki</option>
                                                            <option value="bare">bare</option>
                                                            <option value="ovf">ovf</option>
                                                            <option value="ova">ovs</option>
                                                            <option value="docker">docker</option>
                                                            <option value="compressed">compressed</option>
                                                        </select>
                                                    </div>
                                                    <span className="err_msg" style={ { display: this.state.containerempty ? 'inline-block' : 'none', color: "red" } } >Container format cannot be blank</span>
                                                </div>
                                                <div className="common_txtBox_row" style={ { display: "none" } }>
                                                    <label>Disk Format<span className="question_icon" data-tip data-for="disk" ><svg x="0px" y="0px" viewBox="0 0 22 20" enableBackground="new 0 0 22 20" xmlSpace="preserve">
                                                        <path fillRule="evenodd" clipRule="evenodd" fill="#89A2BE" d="M11,1c5,0,9,4,9,9s-4,9-9,9c-5,0-9-4-9-9S6,1,11,1z"></path>
                                                        <text transform="matrix(1 0 0 1 7.0724 15.4681)" fill="#FFFFFF" fontFamily="'Roboto-Medium'" fontSize="16px">?</text>
                                                    </svg></span><ReactToolTip id="disk" multiline={ true } effect="solid" place="top">
                                                            The file format of the <br></br>virtual disk and the possible values<br></br> for available space
                                                        </ReactToolTip> </label>
                                                    <div className="custom_select_box">
                                                        <select value={ this.state.uploadDiskFormat } onFocus={ () => this.getFocus("disk") } onClick={ () => this.getFocus("disk") } name="uploadDiskFormat" onChange={ this.handleInput } required>
                                                            <option value="" style={ { display: "none" } } disabled>Select the disk format</option>
                                                            <option value="ami">ami</option>
                                                            <option value="ari">ari</option>
                                                            <option value="aki">aki</option>
                                                            <option value="vhd">vhd</option>
                                                            <option value="vhdx">vhdx</option>
                                                            <option value="vmdk">vmdk</option>
                                                            <option value="raw">raw</option>
                                                            <option value="qcow2">qcow2</option>
                                                            <option value="vdi">vdi</option>
                                                            <option value="ploop">ploop</option>
                                                            <option value="iso">iso</option>
                                                        </select>
                                                    </div>
                                                    <span className="err_msg" style={ { display: this.state.diskempty ? 'inline-block' : 'none', color: "red" } } >Disk format cannot be blank</span>
                                                </div>
                                                <div className="cta_wrap">
                                                    <input type="button" name="" value="Upload Image" className="common_cta_btn blue" onClick={ this.uploadImage }></input>
                                                    <input type="button" name="" value="Cancel" className="common_cta_btn transparentGrey" onClick={ (e) => { this.closeUploadImage(e); } }></input>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div> : ""
                        }
                        <div className={ this.state.isAddRegSlider ? "main_slider addRegionSlider active" : "main_slider addRegionSlider" }>
                            <div className="slider_bg_shadow"></div>
                            <div className="slider_wrapper">
                                <div className="main_slider_container">
                                    <div className="close_icon" data-tip data-for="addRegionClose" onClick={ () => this.setState({ isAddRegSlider: false }) }></div>
                                    <ReactToolTip id="addRegionClose" place='left' effect='solid' >Close</ReactToolTip>
                                    <div className="imgModuleRhs_slide_wrap">
                                        <div className="head_block">
                                            <h2>
                                                <span className="icon_img">
                                                    <span className="icon"></span>
                                                </span>Add to Region
                                            </h2>
                                        </div>
                                        <div className="imgModuleRhs_content_wrap">
                                            <p className="info_txt">Select a region where you want the image to be available</p>
                                            <div className="common_txtBox_row">
                                                <label>Regions</label>
                                                <div className={ this.state.regionContainerFocus ? "region_select_container active" : "region_select_container" }>
                                                    <div className="slectBox" onClick={ () => { this.getRegionDropdown(); } }>
                                                        <div className={ this.state.isregionselected ? "search_inp_box optSelect" : "search_inp_box optUnselect" }>
                                                            <input type="text" autoComplete="off" ref={ this.uploadRegionFocus } name="uploadRegion" value={ this.state.uploadRegion } placeholder="Select a Region" onChange={ this.filterDropDown }></input>
                                                            <input type="hidden" name="regionid" value={ this.state.regionid }></input>
                                                        </div>
                                                        <ul>
                                                            <li className="selected_elem"><span className={ this.state.uploadRegion.length > 0 ? "country_flag " + this.state.countryName.toLowerCase() : "" }></span>{ this.state.uploadRegion.length <= 0 ? this.state.uploadRegion : this.state.uploadRegion + " (" + this.state.regionid + ")" }</li>
                                                        </ul>
                                                        <span className="dropArrow"> <svg className="header_nav_dropdown" viewBox="0 0 10 5">
                                                            <title>drop-down</title>
                                                            <polygon className="cls-1" points="5 5 0 0 10 0 5 5"></polygon>
                                                        </svg>
                                                        </span>
                                                    </div>
                                                    <div className="regionSelect_options">

                                                        { this.state.regionListFilter.length <= 0 ?
                                                            <ul className="noSearchRes" style={ { display: this.state.regionListFilter.length <= 0 ? "" : "none" } }>
                                                                <li>No matching region found</li>
                                                            </ul>
                                                            :
                                                            <ul>
                                                                <ScrollArea
                                                                    speed={ 0.8 }
                                                                    style={ { maxHeight: "245px" } }
                                                                    vertical={ true }
                                                                    horizontal={ false }
                                                                    minScrollSize={ 10 }
                                                                    smoothScrolling={ false }
                                                                    verticalScrollbarStyle={ { backgroundColor: "#C1C1C1", opacity: "1" } }
                                                                    verticalContainerStyle={ { backgroundColor: "#F1F1F1", opacity: "1" } }
                                                                    stopScrollPropagation={ true }
                                                                >
                                                                    { this.state.regionListFilter.map((region, i) =>
                                                                        <li style={ { display: this.state.copyImageRegion == region.id ? "none" : "" } } className={ "option_elem " + region.statusClass } key={ i } onMouseDown={ (e) => this.getSelectedRegion(e, region) } disabled={ region.status !== 1 }><span className={ 'country_flag ' + region.countryName.toLowerCase() } ></span>{ region.name } ({ region.id })<span className="algin_right__arrow" style={ { display: region.status === 1 ? 'none' : '' } }>{ region.statusName }</span>
                                                                        </li>
                                                                    ) }

                                                                </ScrollArea>
                                                            </ul>
                                                        }
                                                    </div>
                                                </div>

                                                <span className="err_msg" style={ { display: this.state.regionempty ? 'inline-block' : 'none', color: "red" } } >Region cannot be blank</span>
                                            </div>
                                            <div className="cta_wrap">
                                                <input type="button" name="" value="Add" className="common_cta_btn blue" onClick={ () => this.callCopyRegion() } />
                                                <input type="button" name="" value="Cancel" className="common_cta_btn transparentGrey" onClick={ () => this.setState({ isAddRegSlider: false }) } />
                                            </div>
                                            <p><b>Note:</b> Standard charges will apply.<a href="https://www.idrivecompute.com/faq_plans.htm#additional-charges" target="_blank"> Know More</a></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/*
                    <div className={this.state.enableimageurl?"main_popup import_url_popup active":"main_popup import_url_popup"}>
                    <div className="main_popup_wrapper">import Data from './containerFormat';
import default from './../../services/userService/userservice';
import { RegionService } from './../../services/region.service';
import { ResourceService } from './../../services/resource.service';
import { ScrollArea } from 'react-scrollbar';



                        <div className="main_popup_bg_shadow"></div>
                        <div className="main_popup__inner">
                        <div className="popup_wrap"> <span className="close_icon" dataToggle="tooltip" title="" dataoriginaltitle="Close" onClick = {() =>{
                                    this.setState({
                                        enableimageurl:!this.state.enableimageurl
                                    })
                                }}></span>
                            <div className="popup_header">
                            <div className="sub_title"> Upload an Image</div>
                            </div>
                            <div className="popup_body">
                                <div className="common_txtBox_row">
                                    <label>Enter URL</label>
                                    <input type="text" name="" className="txtBox url_inp"></input>
                                </div>
                            </div>
                            <div className="popup_footer">
                            <div className="popup_footer__btns">
                                <div className="btn transparentBlue_bg" onClick = {() =>{
                                    this.setState({
                                        enableimageurl:!this.state.enableimageurl
                                    })
                                }}>Cancel</div>
                                <div className="btn blue">Next</div>
                            </div>
                            </div>
                        </div>
                        </div>
                    </div>
                            </div>*/}
                    <div className="main_popup delete_image_popup">
                        <div className="main_popup_wrapper">
                            <div className="main_popup_bg_shadow"></div>
                            <div className="main_popup__inner">
                                <div className="popup_wrap"> <span className="close_icon" onClick={ this.closeDeleteImage }></span>
                                    <div className="popup_header">
                                        <div className="sub_title"> Delete</div>
                                    </div>
                                    <div className="popup_body">
                                        <p >This will permanently delete the { this.state.imagetype === "backups" ? "image backup" : this.state.imagetype === 'snapshot' ? "snapshot" : "image" } from your account. The operation is irreversible.</p>
                                        <p style={ { display: this.state.imagetype === 'backups' ? 'none' : '' } }>Deleting a snapshot created for instance cloning will cause the cloning process to fail.</p>
                                        <p >Are you sure you want to delete the { this.state.imagetype === "backups" ? "backup" : this.state.imagetype === 'snapshot' ? "snapshot" : "image" } <b>{ this.state.imagedeletename }</b>?</p>
                                    </div>
                                    <div className="popup_footer">
                                        <div className="popup_footer__btns">
                                            <button className="btn btn_confirm" id="deleteImageFocus" onClick={ this.deleteImage } >Delete</button>
                                            <button className="btn btn_cancel" onClick={ this.closeDeleteImage }>Cancel</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="main_popup upload_image_popup">
                        <div className="main_popup_wrapper">
                            <div className="main_popup_bg_shadow"></div>
                            <div className="main_popup__inner">
                                <div className="popup_wrap">
                                    <span className="close_icon" onClick={ this.fadeOffUploadImageClose }></span>
                                    <div className="popup_header">
                                        <div className="sub_title">Upload</div>
                                    </div>
                                    <div className="popup_body">
                                        <p>This will cancel current image upload. The operation is irreversible.</p>
                                        <p>Are you sure to cancel the current upload ?</p>
                                    </div>
                                    <div className="popup_footer">
                                        <div className="popup_footer__btns">
                                            <button className="btn btn_confirm" id="uploadcancel" onClick={ this.cancelUploadImage }  >Cancel Upload</button>
                                            <button className="btn btn_cancel" onClick={ this.fadeOffUploadImageClose }>Close</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
                <CommonMessage message={ this.state.message } msgType={ this.state.msgType } isUserSubscribed={ this.state.isUserSubscribed } handler={ () => this.setState({ message: '' }) } />
            </body >
        );
    }
}
function asyncCall() {
    return new Promise((resolve) => setTimeout(() => resolve(), 1000));
}
function getFocusForFile() {
    $(".custom_fileUpload_btn").addClass("focus");

}
function getBlurForFile() {
    $(".custom_fileUpload_btn").removeClass("focus");

}

function getReturn(list, key) {

    for(let i = 0; i < list.length; i++) {
        if(list[i].region_id == key) {
            return true;
        }
    }
    return false;
}
export default Images;
